export const global_marketlist = {
  "1": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Tipp",
    "group": "all|score|regular_play"
  },
  "2": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Qualifiziert sich",
    "group": "all|score|cup_tie"
  },
  "3": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welches Team gewinnt das Finale",
    "group": "all|score|cup_tie"
  },
  "4": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welches Team gewinnt Spiel um Platz 3",
    "group": "all|score|cup_tie"
  },
  "5": {
    "14": "{$competitor1} reguläre Spielzeit",
    "15": "{$competitor2} reguläre Spielzeit",
    "16": "{$competitor1} Verlängerung",
    "17": "{$competitor2} Verlängerung",
    "18": "{$competitor1} Elfmeterschießen",
    "19": "{$competitor2} Elfmeterschießen",
    "name": "Wie wird das Spiel entschieden?",
    "group": "all|score|cup_tie"
  },
  "6": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer hat Anstoß?",
    "group": "all|misc"
  },
  "7": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Restzeit",
    "group": "all|score|regular_play"
  },
  "8": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Nächstes Tor",
    "group": "all|score|regular_play"
  },
  "9": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "letztes Tor",
    "group": "all|score|regular_play"
  },
  "10": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "Doppelte Chance",
    "group": "all|score|regular_play"
  },
  "11": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Unentschieden, keine Wette",
    "group": "all|score|regular_play"
  },
  "12": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "{$competitor1} keine Wette",
    "group": "all|score|regular_play"
  },
  "13": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "{$competitor2} keine Wette",
    "group": "all|score|regular_play"
  },
  "14": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "16": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap",
    "group": "all|score|regular_play"
  },
  "18": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter",
    "group": "all|score|regular_play"
  },
  "19": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter",
    "group": "all|score|regular_play"
  },
  "20": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter",
    "group": "all|score|regular_play"
  },
  "26": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade",
    "group": "all|score|regular_play"
  },
  "27": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{$competitor1} Gerade/ungerade",
    "group": "all|score|regular_play"
  },
  "28": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{$competitor2} Gerade/ungerade",
    "group": "all|score|regular_play"
  },
  "29": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Mannschaften treffen",
    "group": "all|score|regular_play"
  },
  "30": {
    "784": "keiner",
    "788": "nur {$competitor1}",
    "790": "nur {$competitor2}",
    "792": "beide Mannschaften",
    "name": "Welche Mannschaft trifft",
    "group": "all|score|regular_play"
  },
  "31": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} ohne Gegentreffer",
    "group": "all|score|regular_play"
  },
  "32": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} ohne Gegentreffer",
    "group": "all|score|regular_play"
  },
  "33": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} gewinnt zu null",
    "group": "all|score|regular_play"
  },
  "34": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} gewinnt zu null",
    "group": "all|score|regular_play"
  },
  "35": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nein",
    "82": "X & ja",
    "84": "X & nein",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nein",
    "name": "Tipp & Beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "36": {
    "90": "{total} + & ja",
    "92": "{total} - & ja",
    "94": "{total} + & nein",
    "96": "{total} - & nein",
    "name": "Über/Unter & Beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "37": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "Tipp & Über/Unter",
    "group": "all|regular_play|combo|incl_ot"
  },
  "38": {
    "1716": "kein Tor",
    "name": "{!goalnr} Torschütze",
    "group": "all|regular_play|scorers"
  },
  "39": {
    "1716": "kein Tor",
    "name": "Letzter Torschütze",
    "group": "all|regular_play|scorers"
  },
  "40": {
    "1716": "kein Tor",
    "name": "Torschütze",
    "group": "all|regular_play|scorers"
  },
  "41": {
    "110": "0:0",
    "114": "1:0",
    "116": "2:0",
    "118": "3:0",
    "120": "4:0",
    "122": "5:0",
    "124": "6:0",
    "126": "0:1",
    "128": "1:1",
    "130": "2:1",
    "132": "3:1",
    "134": "4:1",
    "136": "5:1",
    "138": "0:2",
    "140": "1:2",
    "142": "2:2",
    "144": "3:2",
    "146": "4:2",
    "148": "0:3",
    "150": "1:3",
    "152": "2:3",
    "154": "3:3",
    "156": "0:4",
    "158": "1:4",
    "160": "2:4",
    "162": "0:5",
    "164": "1:5",
    "166": "0:6",
    "name": "Genaues Ergebnis {!score}",
    "group": "all|score|regular_play"
  },
  "45": {
    "274": "0:0",
    "276": "1:0",
    "278": "2:0",
    "280": "3:0",
    "282": "4:0",
    "284": "0:1",
    "286": "1:1",
    "288": "2:1",
    "290": "3:1",
    "292": "4:1",
    "294": "0:2",
    "296": "1:2",
    "298": "2:2",
    "300": "3:2",
    "302": "4:2",
    "304": "0:3",
    "306": "1:3",
    "308": "2:3",
    "310": "3:3",
    "312": "4:3",
    "314": "0:4",
    "316": "1:4",
    "318": "2:4",
    "320": "3:4",
    "322": "4:4",
    "324": "andere",
    "name": "Genaues Ergebnis",
    "group": "all|score|regular_play"
  },
  "46": {
    "326": "0:0 0:0",
    "328": "0:0 0:1",
    "330": "0:0 0:2",
    "332": "0:0 0:3",
    "334": "0:0 1:0",
    "336": "0:0 1:1",
    "338": "0:0 1:2",
    "340": "0:0 2:0",
    "342": "0:0 2:1",
    "344": "0:0 3:0",
    "346": "0:0 4+",
    "348": "0:1 0:1",
    "350": "0:1 0:2",
    "352": "0:1 0:3",
    "354": "0:1 1:1",
    "356": "0:1 1:2",
    "358": "0:1 2:1",
    "360": "0:1 4+",
    "362": "0:2 0:2",
    "364": "0:2 0:3",
    "366": "0:2 1:2",
    "368": "0:2 4+",
    "370": "0:3 0:3",
    "372": "0:3 4+",
    "374": "1:0 1:0",
    "376": "1:0 1:1",
    "378": "1:0 1:2",
    "380": "1:0 2:0",
    "382": "1:0 2:1",
    "384": "1:0 3:0",
    "386": "1:0 4+",
    "388": "1:1 1:1",
    "390": "1:1 1:2",
    "392": "1:1 2:1",
    "394": "1:1 4+",
    "396": "1:2 1:2",
    "398": "1:2 4+",
    "400": "2:0 2:0",
    "402": "2:0 2:1",
    "404": "2:0 3:0",
    "406": "2:0 4+",
    "408": "2:1 2:1",
    "410": "2:1 4+",
    "412": "3:0 3:0",
    "414": "3:0 4+",
    "416": "4+ 4+",
    "name": "HZ/reg. Spielzeit - Genaues Ergebnis",
    "group": "all|score|regular_play"
  },
  "47": {
    "418": "{$competitor1}/{$competitor1}",
    "420": "{$competitor1}/X",
    "422": "{$competitor1}/{$competitor2}",
    "424": "X/{$competitor1}",
    "426": "unentschieden / unentschieden",
    "428": "X/{$competitor2}",
    "430": "{$competitor2}/{$competitor1}",
    "432": "{$competitor2}/X",
    "434": "{$competitor2}/{$competitor2}",
    "name": "HZ/reg. Spielzeit",
    "group": "all|score|regular_play"
  },
  "48": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird beide Hälften gewinnen",
    "group": "all|score|regular_play"
  },
  "49": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird beide Hälften gewinnen",
    "group": "all|score|regular_play"
  },
  "50": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1}Sieger in einer der HZ",
    "group": "all|score|regular_play"
  },
  "51": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2}Sieger in einer der HZ",
    "group": "all|score|regular_play"
  },
  "52": {
    "436": "1. HZ",
    "438": "2. HZ",
    "440": "gleich",
    "name": "HZ mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "53": {
    "436": "1. HZ",
    "438": "2. HZ",
    "440": "gleich",
    "name": "{$competitor1} HZ mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "54": {
    "436": "1. HZ",
    "438": "2. HZ",
    "440": "gleich",
    "name": "{$competitor2} HZ mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "55": {
    "806": "nein/nein",
    "808": "ja/nein",
    "810": "ja/ja",
    "812": "nein/ja",
    "name": "1. HZ / 2. HZ Beide Mannschaften treffen",
    "group": "all|score|regular_play"
  },
  "56": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird beide Hälften treffen",
    "group": "all|score|regular_play"
  },
  "57": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird beide Hälften treffen",
    "group": "all|score|regular_play"
  },
  "58": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Hälften {total} +",
    "group": "all|score|regular_play"
  },
  "59": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Hälften {total} -",
    "group": "all|score|regular_play"
  },
  "60": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1. HZ - Tipp",
    "group": "all|score|1st_half"
  },
  "61": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1. HZ - Restzeit",
    "group": "all|score|1st_half"
  },
  "62": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - {!goalnr} Tor",
    "group": "all|score|1st_half"
  },
  "63": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "1. HZ - Doppelte Chance",
    "group": "all|score|1st_half"
  },
  "64": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1. HZ - unentschieden, keine Wette",
    "group": "all|score|1st_half"
  },
  "65": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1. HZ - Handicap {hcp}",
    "group": "all|score|1st_half"
  },
  "66": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1. HZ - Handicap",
    "group": "all|score|1st_half"
  },
  "68": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - Über/Unter",
    "group": "all|score|1st_half"
  },
  "69": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor1} Über/Unter",
    "group": "all|score|1st_half"
  },
  "70": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor2} Über/Unter",
    "group": "all|score|1st_half"
  },
  "74": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. HZ - Gerade/ungerade",
    "group": "all|score|1st_half"
  },
  "75": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ - Beide Mannschaften treffen",
    "group": "all|score|1st_half"
  },
  "76": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ- {$competitor1} ohne Gegentreffer",
    "group": "all|score|1st_half"
  },
  "77": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ- {$competitor2} ohne Gegentreffer",
    "group": "all|score|1st_half"
  },
  "78": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nein",
    "82": "X & ja",
    "84": "X & nein",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nein",
    "name": "1. HZ- Tipp & Beide Mannschaften treffen",
    "group": "all|combo|1st_half"
  },
  "79": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1. HZ- Tipp & Über/Unter",
    "group": "all|combo|1st_half"
  },
  "80": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "1. HZ- Genaues Ergebnis {!score}",
    "group": "all|score|1st_half"
  },
  "81": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "andere",
    "name": "1. HZ- Genaues Ergebnis",
    "group": "all|score|1st_half"
  },
  "83": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2. HZ- Tipp",
    "group": "all|score|2nd_half"
  },
  "84": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "2. HZ - {!goalnr} Tor",
    "group": "all|score|2nd_half"
  },
  "85": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "2. HZ - Doppelte Chance",
    "group": "all|score|2nd_half"
  },
  "86": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2. HZ - unentschieden, keine Wette",
    "group": "all|score|2nd_half"
  },
  "87": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "2. HZ - Handicap {hcp}",
    "group": "all|score|2nd_half"
  },
  "88": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2. HZ - Handicap",
    "group": "all|score|2nd_half"
  },
  "90": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2. HZ - Über/Unter",
    "group": "all|score|2nd_half"
  },
  "91": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2. HZ - {$competitor1} Über/Unter",
    "group": "all|score|2nd_half"
  },
  "92": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2. HZ - {$competitor2} Über/Unter",
    "group": "all|score|2nd_half"
  },
  "94": {
    "70": "ungerade",
    "72": "gerade",
    "name": "2. HZ - Gerade/ungerade",
    "group": "all|score|2nd_half"
  },
  "95": {
    "74": "ja",
    "76": "nein",
    "name": "2. HZ - Beide Mannschaften treffen",
    "group": "all|score|2nd_half"
  },
  "96": {
    "74": "ja",
    "76": "nein",
    "name": "2. HZ - {$competitor1} ohne Gegentreffer",
    "group": "all|score|2nd_half"
  },
  "97": {
    "74": "ja",
    "76": "nein",
    "name": "2. HZ - {$competitor2} ohne Gegentreffer",
    "group": "all|score|2nd_half"
  },
  "98": {
    "546": "0:0",
    "548": "0:1",
    "550": "0:2",
    "552": "1:0",
    "554": "1:1",
    "556": "1:2",
    "558": "2:0",
    "560": "2:1",
    "562": "2:2",
    "564": "andere",
    "name": "2. HZ - Genaues Ergebnis",
    "group": "all|score|2nd_half"
  },
  "100": {
    "584": "1-15",
    "586": "16-30",
    "588": "31-45",
    "590": "46-60",
    "592": "61-75",
    "594": "76-90",
    "596": "garnicht",
    "name": "Wann wird das {!goalnr}Tor erzielt? (15 Min Intervall )",
    "group": "all|score|regular_play"
  },
  "101": {
    "598": "1-10",
    "600": "11-20",
    "602": "21-30",
    "604": "31-40",
    "606": "41-50",
    "608": "51-60",
    "610": "61-70",
    "612": "71-80",
    "614": "81-90",
    "616": "garnicht",
    "name": "Wann wird das {!goalnr}Tor erzielt? (10 Min Intervall )",
    "group": "all|score|regular_play"
  },
  "102": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 Minuten - Tipp von{from} bis {to}",
    "group": "all|score|15_min"
  },
  "103": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "15 Minuten - {!goalnr} Tor von {from} bis {to}",
    "group": "all|score|15_min"
  },
  "104": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 Minuten - Über/Unter von {from} bis {to}",
    "group": "all|score|15_min"
  },
  "105": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 Minuten - Tipp von{from} bis {to}",
    "group": "all|score|10_min"
  },
  "106": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "10 Minuten - {!goalnr} Tor von {from} bis {to}",
    "group": "all|score|10_min"
  },
  "107": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 Minuten - Über/Unter von {from} bis {to}",
    "group": "all|score|10_min"
  },
  "108": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 Minuten - Tipp von{from} bis {to}",
    "group": "all|score|5_min"
  },
  "109": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "5 Minuten - {!goalnr} Tor von {from} bis {to}",
    "group": "all|score|5_min"
  },
  "110": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 Minuten - Über/Unter von {from} bis {to}",
    "group": "all|score|5_min"
  },
  "112": {
    "74": "ja",
    "76": "nein",
    "name": "Verlängerung & Tor",
    "group": "all|combo|ot"
  },
  "113": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Verlängerung - Tipp",
    "group": "all|score|ot"
  },
  "114": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Verlängerung - Wer gewinnt die verbleibende Spielzeit?",
    "group": "all|score|ot"
  },
  "115": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Verlängerung - {!goalnr} Tor",
    "group": "all|score|ot"
  },
  "116": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Verlängerung - Über/Unter",
    "group": "all|score|ot"
  },
  "117": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Verlängerung - Handicap",
    "group": "all|score|ot"
  },
  "118": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "Verlängerung - Genaues Ergebnis {!score}",
    "group": "all|score|ot"
  },
  "119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Verlängerung 1. HZ - Tipp",
    "group": "all|score|ot_1st_half"
  },
  "120": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Verlängerung 1. HZ - Handicap",
    "group": "all|score|ot_1st_half"
  },
  "121": {
    "618": "0:0",
    "620": "1:0",
    "622": "2:0",
    "624": "0:1",
    "626": "1:1",
    "628": "0:2",
    "name": "Verlängerung 1. HZ - Genaues Ergebnis {!score}",
    "group": "all|score|ot_1st_half"
  },
  "122": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Elfmeterschießen geben?",
    "group": "all|score|incl_ot"
  },
  "123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Elfmeterschießen - Gewinner",
    "group": "all|score|pen_so"
  },
  "124": {
    "74": "ja",
    "76": "nein",
    "name": "Elfmeterschießen - {!penaltynr} Elfmeter erzielt",
    "group": "all|score|pen_so"
  },
  "125": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Elfmeterschießen - {!goalnr} Tor",
    "group": "all|score|pen_so"
  },
  "126": {
    "630": "{$competitor1} mit 1",
    "632": "{$competitor1} mit 2",
    "634": "{$competitor1} mit 3+",
    "636": "{$competitor2} mit 1",
    "638": "{$competitor2} mit 2",
    "640": "{$competitor2} mit 3+",
    "name": "Elfmeterschießen - Gewinnspanne",
    "group": "all|score|pen_so"
  },
  "127": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Elfmeterschießen - Über/Unter",
    "group": "all|score|pen_so"
  },
  "128": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Elfmeterschießen - {$competitor1} Über/Unter",
    "group": "all|score|pen_so"
  },
  "129": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Elfmeterschießen - {$competitor2} Über/Unter",
    "group": "all|score|pen_so"
  },
  "131": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Elfmeterschießen - Gerade/ungerade",
    "group": "all|score|pen_so"
  },
  "132": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Elfmeterschießen - {$competitor1} Gerade/ungerade",
    "group": "all|score|pen_so"
  },
  "133": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Elfmeterschießen - {$competitor2} Gerade/ungerade",
    "group": "all|score|pen_so"
  },
  "134": {
    "656": "{$competitor1} & {total} -",
    "658": "{$competitor2} & {total} -",
    "660": "{$competitor1} & {total} +",
    "662": "{$competitor2} & {total} +",
    "name": "Elfmeterschießen - Gewinner & Über/Unter",
    "group": "all|combo|pen_so"
  },
  "135": {
    "1767": "0:1",
    "1768": "0:2",
    "1769": "0:3",
    "1770": "1:0",
    "1771": "1:2",
    "1772": "1:3",
    "1773": "1:4",
    "1774": "2:0",
    "1775": "2:1",
    "1776": "2:3",
    "1777": "2:4",
    "1778": "3:0",
    "1779": "3:1",
    "1780": "3:2",
    "1781": "3:4",
    "1782": "3:5",
    "1783": "4:1",
    "1784": "4:2",
    "1785": "4:3",
    "1786": "4:5",
    "1787": "5:3",
    "1788": "5:4",
    "1789": "andere",
    "name": "Elfmeterschießen - Genaues Ergebnis",
    "group": "all|score|pen_so"
  },
  "136": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Karten Tipp",
    "group": "all|regular_play|bookings"
  },
  "137": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!bookingnr} Karten",
    "group": "all|regular_play|bookings"
  },
  "138": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Strafpunkte",
    "group": "all|regular_play|bookings"
  },
  "139": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Karten",
    "group": "all|regular_play|bookings"
  },
  "140": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter Karten",
    "group": "all|regular_play|bookings"
  },
  "141": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter Karten",
    "group": "all|regular_play|bookings"
  },
  "142": {
    "710": "0-3",
    "712": "4",
    "714": "5",
    "716": "6",
    "718": "7",
    "720": "8",
    "722": "9",
    "724": "10",
    "726": "11",
    "728": "12+",
    "name": "Genaue Anzahl Karten",
    "group": "all|regular_play|bookings"
  },
  "143": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor1} Genaue Anzahl Karten",
    "group": "all|regular_play|bookings"
  },
  "144": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor2} Genaue Anzahl Karten",
    "group": "all|regular_play|bookings"
  },
  "146": {
    "74": "ja",
    "76": "nein",
    "name": "Platzverweise",
    "group": "all|regular_play|bookings"
  },
  "147": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} Platzverweise",
    "group": "all|regular_play|bookings"
  },
  "148": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} Platzverweise",
    "group": "all|regular_play|bookings"
  },
  "149": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1. HZ - Karten Tipp",
    "group": "all|1st_half|bookings"
  },
  "150": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - {!bookingnr} Karte",
    "group": "all|1st_half|bookings"
  },
  "151": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - Über/Unter Strafpunkte",
    "group": "all|1st_half|bookings"
  },
  "152": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - Über/Unter Karten",
    "group": "all|1st_half|bookings"
  },
  "153": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor1} Über/Unter Karten",
    "group": "all|1st_half|bookings"
  },
  "154": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor2} Über/Unter Karten",
    "group": "all|1st_half|bookings"
  },
  "155": {
    "1760": "0",
    "1761": "1",
    "1762": "2",
    "1763": "3",
    "1764": "4",
    "1765": "5",
    "1766": "6+",
    "name": "1. HZ - Genaue Anzahl Karten",
    "group": "all|1st_half|bookings"
  },
  "156": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1. HZ - {$competitor1} Genaue Anzahl Karten",
    "group": "all|1st_half|bookings"
  },
  "157": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1. HZ - {$competitor2} Genaue Anzahl Karten",
    "group": "all|1st_half|bookings"
  },
  "159": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ - Platzverweise",
    "group": "all|1st_half|bookings"
  },
  "160": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ - {$competitor1} Platzverweise",
    "group": "all|1st_half|bookings"
  },
  "161": {
    "74": "ja",
    "76": "nein",
    "name": "1. HZ - {$competitor2} Platzverweise",
    "group": "all|1st_half|bookings"
  },
  "162": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Ecken Tipp",
    "group": "all|regular_play|corners"
  },
  "163": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!cornernr} Ecke",
    "group": "all|regular_play|corners"
  },
  "164": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Letzte Ecke",
    "group": "all|regular_play|corners"
  },
  "165": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Ecken Handicap",
    "group": "all|regular_play|corners"
  },
  "166": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Ecken",
    "group": "all|regular_play|corners"
  },
  "167": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter Ecken",
    "group": "all|regular_play|corners"
  },
  "168": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter Ecken",
    "group": "all|regular_play|corners"
  },
  "172": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade Ecken",
    "group": "all|regular_play|corners"
  },
  "173": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1. HZ - Ecken Tipp",
    "group": "all|1st_half|corners"
  },
  "174": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - {!cornernr} Ecke",
    "group": "all|1st_half|corners"
  },
  "175": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - Letzte Ecke",
    "group": "all|1st_half|corners"
  },
  "176": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1. HZ - Ecken Handicap",
    "group": "all|1st_half|corners"
  },
  "177": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - Über/Unter Ecken",
    "group": "all|1st_half|corners"
  },
  "178": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor1} Über/Unter Ecken",
    "group": "all|1st_half|corners"
  },
  "179": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor2} Über/Unter Ecken",
    "group": "all|1st_half|corners"
  },
  "180": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1. HZ - {$competitor1} Genaue Anzahl Ecken",
    "group": "all|1st_half|corners"
  },
  "181": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1. HZ - {$competitor2} Genaue Anzahl Ecken",
    "group": "all|1st_half|corners"
  },
  "183": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. HZ - Gerade/ungerade Ecken",
    "group": "all|1st_half|corners"
  },
  "184": {
    "814": "{$competitor1} Tor & {$competitor1}",
    "816": "{$competitor1} Tor & unentschieden",
    "818": "{$competitor1} Tor & {$competitor2}",
    "820": "{$competitor2} Tor & {$competitor1}",
    "822": "{$competitor2} Tor & unentschieden",
    "824": "{$competitor2} Tor & {$competitor2}",
    "826": "kein Tor",
    "name": "{!goalnr} Tor & Tipp",
    "group": "all|regular_play|combo"
  },
  "186": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Gewinner",
    "group": "all|score|regular_play"
  },
  "187": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Spiel Handicap",
    "group": "all|score|regular_play"
  },
  "188": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Satz Handicap",
    "group": "all|score|regular_play"
  },
  "189": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Spiele",
    "group": "all|score|regular_play"
  },
  "190": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter Spiele",
    "group": "all|score|regular_play"
  },
  "191": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter Spiele",
    "group": "all|score|regular_play"
  },
  "192": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird einen Satz gewinnen",
    "group": "all|score|regular_play"
  },
  "193": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird einen Satz gewinnen",
    "group": "all|score|regular_play"
  },
  "194": {
    "74": "ja",
    "76": "nein",
    "name": "Irgendein Satz zu null",
    "group": "all|score|regular_play"
  },
  "195": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Tiebreak geben",
    "group": "all|score|regular_play"
  },
  "198": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade Spiele",
    "group": "all|score|regular_play"
  },
  "201": {
    "861": "{$competitor1}/{$competitor1}",
    "862": "{$competitor2}/{$competitor1}",
    "863": "{$competitor1}/{$competitor2}",
    "864": "{$competitor2}/{$competitor2}",
    "name": "Doppeltes Ergebnis (1. Satz / Spiel)",
    "group": "all|score|regular_play"
  },
  "202": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz - Gewinner",
    "group": "all|score|set"
  },
  "203": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} Satz - Spiel Handicap",
    "group": "all|score|set"
  },
  "204": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - Über/Unter Spiele",
    "group": "all|score|set"
  },
  "205": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!setnr} Satz - Gerade/ungerade Spiele",
    "group": "all|score|set"
  },
  "206": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz - Wird es ein Tiebreak geben",
    "group": "all|score|set"
  },
  "207": {
    "865": "6:0",
    "866": "6:1",
    "867": "6:2",
    "868": "6:3",
    "869": "6:4",
    "870": "7:5",
    "871": "7:6",
    "872": "0:6",
    "873": "1:6",
    "874": "2:6",
    "875": "3:6",
    "876": "4:6",
    "877": "5:7",
    "878": "6:7",
    "name": "{!setnr} Satz - Genaues Ergebnis",
    "group": "all|score|set"
  },
  "208": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz - Zuerst {games} Spiele",
    "group": "all|score|set"
  },
  "209": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} Satz - {!gamenrX} und {!gamenrY} Gewinner Spiel",
    "group": "all|score|game"
  },
  "210": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz Spiel {gamenr} - Gewinner",
    "group": "all|score|game"
  },
  "211": {
    "882": "4",
    "883": "5",
    "884": "6",
    "885": "7+",
    "name": "{!setnr} Satz Spiel {gamenr} - Genaue Anzahl Punkte",
    "group": "all|score|game"
  },
  "212": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Spiel {gamenr} - Einstand",
    "group": "all|score|game"
  },
  "213": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!setnr} Satz Spiel {gamenr} - Gerade/ungerade Punkte",
    "group": "all|score|game"
  },
  "214": {
    "886": "{$competitor1} zu 0",
    "887": "{$competitor1} zu 15",
    "888": "{$competitor1} zu 30",
    "889": "{$competitor1} zu 40",
    "890": "{$competitor2} zu 0",
    "891": "{$competitor2} zu 15",
    "892": "{$competitor2} zu 30",
    "893": "{$competitor2} zu 40",
    "name": "{!setnr} Satz Spiel {gamenr} - Genaues Ergebnis",
    "group": "all|score|game"
  },
  "215": {
    "894": "{%server} zu 0",
    "895": "{%server} zu 15",
    "896": "{%server} zu 30",
    "897": "{%server} zu 40",
    "898": "Break",
    "name": "{!setnr} Satz Spiel {gamenr} - Genaues Ergebnis oder Break",
    "group": "all|score|game"
  },
  "216": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz Spiel {gamenr} - Zuerst {pointnr} Punkte",
    "group": "all|score|points"
  },
  "217": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} Satz Spiel {gamenr} - Gewinner der ersten {pointnr} Punkte",
    "group": "all|score|points"
  },
  "218": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz Spiel {gamenr} - {!pointnr} Punkt",
    "group": "all|score|points"
  },
  "219": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Gewinner (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "220": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es eine OT geben",
    "group": "all|score|regular_play"
  },
  "221": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!scorenr} Ergebnis (inkl. OT)",
    "group": "all"
  },
  "222": {
    "901": "Touchdown",
    "902": "Fieldgoal",
    "903": "andere",
    "904": "keiner",
    "name": "{!scorenr} Score-Typ (inkl. OT)",
    "group": "all"
  },
  "223": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "224": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US Spread (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "225": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "226": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "US Über/Unter (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "227": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "228": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "229": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "230": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst {pointnr} Punkte (inkl. OT)?",
    "group": "all|score|incl_ot"
  },
  "231": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2. HZ - Handicap (inkl. OT)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "232": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2. HZ - Über/Unter (inkl. OT)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "234": {
    "920": "1. Viertel",
    "921": "2. Viertel",
    "922": "3. Viertel",
    "923": "4. Viertel",
    "924": "beide gleich",
    "name": "Viertel mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "235": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} Viertel - Tipp",
    "group": "all|score|quarter"
  },
  "236": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} Viertel - Über/Unter",
    "group": "all|score|quarter"
  },
  "237": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Punkte Handicap",
    "group": "all|score|regular_play"
  },
  "238": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Anzahl Punkte",
    "group": "all|score|regular_play"
  },
  "245": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} Spiel - Gewinner",
    "group": "all|score|game"
  },
  "246": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!gamenr} Spiel - Punkte Handicap",
    "group": "all|score|game"
  },
  "247": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!gamenr} Spiel - Anzahl Punkte",
    "group": "all|score|game"
  },
  "248": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!gamenr} Spiel - Gerade/ungerade",
    "group": "all|score|game"
  },
  "250": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} Spiel - Wer erreicht zuerst {pointnr} Punkte?",
    "group": "all|score|game"
  },
  "251": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Gewinner (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "252": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Tipp (inkl. Extra Innings)",
    "group": "all"
  },
  "253": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Wer gewinnt die verbleibende Spielzeit (inkl. Extra Innings)?",
    "group": "all|score|incl_ei"
  },
  "254": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "255": {
    "630": "{$competitor1} mit 1",
    "632": "{$competitor1} mit 2",
    "634": "{$competitor1} mit 3+",
    "636": "{$competitor2} mit 1",
    "638": "{$competitor2} mit 2",
    "640": "{$competitor2} mit 3+",
    "name": "Gewinnspanne (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "256": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "257": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US Spread (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "258": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "259": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "US Über/Unter (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "260": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "261": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "262": {
    "939": "{total} -",
    "940": "genau {total}",
    "941": "{total} +",
    "name": "Über/Unter (darüber-exakt-unter) (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "264": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "265": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "Tipp & Über/Unter (inkl. Extra Innings)",
    "group": "all|combo|incl_ei"
  },
  "266": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!runnr} Lauf (inkl. Extra Innings)",
    "group": "all|score|incl_ei"
  },
  "267": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst {runnr} Läufe (inkl. Extra Innings)?",
    "group": "all|score|incl_ei"
  },
  "268": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Extra-Inning geben?",
    "group": "all|score|regular_play"
  },
  "269": {
    "74": "ja",
    "76": "nein",
    "name": "Wird {$competitor1} im 9. Inning geschlagen?",
    "group": "all|score|regular_play"
  },
  "270": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Team mit den meist gewonnen Innings",
    "group": "all|score|regular_play"
  },
  "271": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Welches Team gewinnt das Inning mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "272": {
    "951": "1. Inning",
    "952": "2. Inning",
    "953": "3. Inning",
    "954": "4. Inning",
    "955": "5. Inning",
    "956": "6. Inning",
    "957": "7. Inning",
    "958": "8. Inning",
    "959": "9. Inning",
    "960": "gleich",
    "name": "Inning mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "273": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Genaue Anzahl der Läufe im Inning mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "274": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings 1 bis 5 - Tipp",
    "group": "all|score|5_innings"
  },
  "275": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings 1 bis 5 - Handicap",
    "group": "all|score|5_innings"
  },
  "276": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis 5 - Über/Unter",
    "group": "all|score|5_innings"
  },
  "277": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis 5 - {$competitor1} Über/Unter",
    "group": "all|score|5_innings"
  },
  "278": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis 5 - {$competitor2} Über/Unter",
    "group": "all|score|5_innings"
  },
  "279": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings 1 bis Anfang 5tes - Tipp",
    "group": "all|score|4.5_innings"
  },
  "280": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings 1 bis Anfang 5tes - Handicap",
    "group": "all|score|4.5_innings"
  },
  "281": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis Anfang 5tes - Über/Unter",
    "group": "all|score|4.5_innings"
  },
  "282": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis Anfang 5tes - {$competitor1} Über/Unter",
    "group": "all|score|4.5_innings"
  },
  "283": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings 1 bis Anfang 5tes - {$competitor2} Über/Unter",
    "group": "all|score|4.5_innings"
  },
  "284": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings {from} bis {to} - Über/Unter",
    "group": "all|score|3_innings"
  },
  "285": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings {from} bis {to} - {$competitor1} Über/Unter",
    "group": "all|score|3_innings"
  },
  "286": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Innings {from} bis {to} - {$competitor2} Über/Unter",
    "group": "all|score|3_innings"
  },
  "287": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning - Tipp",
    "group": "all|score|inning"
  },
  "288": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - Über/Unter",
    "group": "all|score|inning"
  },
  "289": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer gewinnt den Sprungball?",
    "group": "all|misc"
  },
  "291": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!pointnr} Punkt (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "292": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Gewinner & Über/Unter (inkl. OT)",
    "group": "all|combo|incl_ot"
  },
  "293": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2. HZ - Tipp (inkl. OT)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "294": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2. HZ - unentschieden, keine Wette (inkl. OT)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "295": {
    "70": "ungerade",
    "72": "gerade",
    "name": "2. HZ - Gerade/ungerade (inkl. Extra Innings)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "297": {
    "939": "{total} -",
    "940": "genau {total}",
    "941": "{total} +",
    "name": "Über/Unter (darüber-exakt-unter)",
    "group": "all|score|regular_play"
  },
  "300": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|regular_play"
  },
  "301": {
    "1002": "{$competitor1} mit 3+",
    "1003": "{$competitor2} mit 3+",
    "1004": "andere",
    "name": "{!quarternr} Viertel - Gewinnspanne",
    "group": "all|score|quarter"
  },
  "302": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} Viertel - unentschieden, keine Wette",
    "group": "all|score|quarter"
  },
  "303": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} Viertel - Handicap",
    "group": "all|score|quarter"
  },
  "304": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!quarternr} Viertel - Gerade/ungerade",
    "group": "all|score|quarter"
  },
  "305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} Viertel - Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|quarter"
  },
  "309": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} Satz - Punkte Handicap",
    "group": "all|score|set"
  },
  "310": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - Anzahl Punkte",
    "group": "all|score|set"
  },
  "311": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!setnr} Satz - Gerade/ungerade",
    "group": "all|score|set"
  },
  "312": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz - {!pointnr} Punkt",
    "group": "all|score|set"
  },
  "313": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz - Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|set"
  },
  "314": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Sätze",
    "group": "all|score|regular_play"
  },
  "315": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} Satz - Tipp",
    "group": "all|score|set"
  },
  "316": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz - unentschieden, keine Wette",
    "group": "all|score|set"
  },
  "317": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!setnr} Satz - Handicap {hcp}",
    "group": "all|score|set"
  },
  "318": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor1} Über/Unter",
    "group": "all|score|set"
  },
  "319": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor2} Über/Unter",
    "group": "all|score|set"
  },
  "322": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satzende {endnr} - Gewinner",
    "group": "all|score|end"
  },
  "323": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satzende {endnr} - Über/Unter",
    "group": "all|score|end"
  },
  "324": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "{!setnr} Satzende {endnr} - Genaue Anzahl Punkte",
    "group": "all|score|end"
  },
  "325": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!setnr} Satzende {endnr} - Gerade/ungerade",
    "group": "all|score|end"
  },
  "326": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Map Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "327": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Map Handicap",
    "group": "all|score|regular_play"
  },
  "328": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Anzahl Maps",
    "group": "all|score|regular_play"
  },
  "330": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Gewinner (inkl. OT)",
    "group": "all|score|map_incl_ot"
  },
  "331": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} Map - Runden Handicap (inkl. OT)",
    "group": "all|score|map_incl_ot"
  },
  "332": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map - Anzahl Runden (inkl. OT)",
    "group": "all|score|map_incl_ot"
  },
  "333": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Kill",
    "group": "all|kills|map"
  },
  "334": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!mapnr} Map - Tipp",
    "group": "all|score|map"
  },
  "335": {
    "74": "ja",
    "76": "nein",
    "name": "{!mapnr} Map - Wird es eine Verlängerung geben",
    "group": "all|score|map"
  },
  "337": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map Messer Runde - Gewinner",
    "group": "all|round"
  },
  "338": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map Runde {roundnr}- Gewinner",
    "group": "all|round"
  },
  "340": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Gewinner (inkl. Super over)",
    "group": "all|score|incl_so"
  },
  "341": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Super over geben?",
    "group": "all|score|regular_play"
  },
  "342": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Gleichstand geben?",
    "group": "all|score|regular_play"
  },
  "343": {
    "1031": "gefangen",
    "1032": "bowled",
    "1033": "lbw",
    "1034": "run out",
    "1035": "stumped",
    "1036": "andere",
    "name": "{!inningnr} Inning - {!dismissalnr} Dismissal Methode",
    "group": "all|dismissal|innings"
  },
  "344": {
    "1037": "gefangen",
    "1038": "nicht gefangen",
    "name": "{!inningnr} Inning - {!dismissalnr} Dismissal Methode (begrenzt)",
    "group": "all|dismissal|innings"
  },
  "347": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "{!inningnr} Inning - Welches Team gewinnt das Over mit den meisten Punkten",
    "group": "all|score|innings"
  },
  "349": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter im {!dismissalnr} Dismissal",
    "group": "all|score|innings"
  },
  "350": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter im {!dismissalnr} Dismissal",
    "group": "all|score|innings"
  },
  "351": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning Overs null zu {overnr} - Tipp",
    "group": "all|score|x_overs"
  },
  "352": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Overs null zu {overnr} - {$competitor1} Über/Unter",
    "group": "all|score|x_overs"
  },
  "353": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Overs null zu {overnr} - {$competitor2} Über/Unter",
    "group": "all|score|x_overs"
  },
  "356": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor1} Über/Unter",
    "group": "all|score|over"
  },
  "357": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} Über/Unter",
    "group": "all|score|over"
  },
  "358": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. Over - Über/Unter",
    "group": "all|score|over"
  },
  "359": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor1} Gerade/ungerade",
    "group": "all|score|over"
  },
  "360": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} Gerade/ungerade",
    "group": "all|score|over"
  },
  "361": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. Over - Gerade/ungerade",
    "group": "all|score|over"
  },
  "362": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor1} Über/Unter",
    "group": "all|score|delivery"
  },
  "363": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor2} Über/Unter",
    "group": "all|score|delivery"
  },
  "365": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Satz Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "366": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Runden handicap",
    "group": "all|score|regular_play"
  },
  "367": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Runden",
    "group": "all|score|regular_play"
  },
  "368": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade Sätze",
    "group": "all|score|regular_play"
  },
  "370": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} Satz - Wer gewinnt die verbleibende Spielzeit?",
    "group": "all|score|set"
  },
  "371": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} Satz - Runden Handicap",
    "group": "all|score|set"
  },
  "372": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - Über/Unter Runden",
    "group": "all|score|set"
  },
  "373": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!setnr} Satz - Gerade/ungerade Runden",
    "group": "all|score|set"
  },
  "375": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} Satz Runde {legnr} - Gewinner",
    "group": "all|score|leg"
  },
  "376": {
    "1039": "{total} +",
    "1040": "{total} -",
    "name": "{!setnr} Satz Runde {legnr} - Über/Unter darts",
    "group": "all|score|leg"
  },
  "377": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr} Satz Runde {legnr} - Spieler mit den meisten Punkten im {!visitnr} Visit",
    "group": "all|score|visit"
  },
  "378": {
    "1044": "0-89",
    "1045": "90-100",
    "1046": "101+",
    "name": "{!setnr} Satz Runde {legnr} - Punktebereich im {!visitnr} Visit",
    "group": "all|score|visit"
  },
  "379": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Runde {legnr} - Checkout Ergebnis {score}+",
    "group": "all|leg|checkout"
  },
  "380": {
    "1049": "rot",
    "1050": "grün",
    "name": "{!setnr} Satz Runde {legnr} - Checkout Farbe",
    "group": "all|leg|checkout"
  },
  "381": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "Die meisten 180s",
    "group": "all|regular_play|180s"
  },
  "382": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!xth} Spieler der ein 180 erzielt",
    "group": "all|regular_play|180s"
  },
  "383": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "180s Handicap",
    "group": "all|regular_play|180s"
  },
  "384": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter 180s",
    "group": "all|regular_play|180s"
  },
  "385": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter 180s",
    "group": "all|regular_play|180s"
  },
  "386": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter 180s",
    "group": "all|regular_play|180s"
  },
  "387": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr} Satz - Die meisten 180s",
    "group": "all|set|180s"
  },
  "388": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - Über/Unter 180s",
    "group": "all|set|180s"
  },
  "389": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor1} Über/Unter 180s",
    "group": "all|set|180s"
  },
  "390": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor2} Über/Unter 180s",
    "group": "all|set|180s"
  },
  "391": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Leg {legnr} - Erzielt ein Spieler eine 180",
    "group": "all|leg|180s"
  },
  "392": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Runde {legnr} - {$competitor1} erzielt eine 180",
    "group": "all|leg|180s"
  },
  "393": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Runde {legnr} - {$competitor2} erzielt eine 180",
    "group": "all|leg|180s"
  },
  "395": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Gewinner",
    "group": "all|map"
  },
  "396": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Aegis",
    "group": "all|map|structures"
  },
  "397": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Tower",
    "group": "all|map|structures"
  },
  "398": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Baracken",
    "group": "all|map|structures"
  },
  "401": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Genaues Ergebnis {!score}",
    "group": "all|score|regular_play"
  },
  "402": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "1. HZ - Genaues Ergebnis {!score}",
    "group": "all|score|1st_half"
  },
  "404": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!goalnr} Tor (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "405": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst {goalnr} Tore (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "406": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Gewinner (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "407": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!goalnr} Tor (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "408": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "409": {
    "630": "{$competitor1} mit 1",
    "632": "{$competitor1} mit 2",
    "634": "{$competitor1} mit 3+",
    "636": "{$competitor2} mit 1",
    "638": "{$competitor2} mit 2",
    "640": "{$competitor2} mit 3+",
    "name": "Gewinnspanne (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "410": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "411": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "412": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "413": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "US Über/Unter (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "414": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "415": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "419": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "420": {
    "1475": "beide",
    "1476": "nur {$competitor1}",
    "1477": "nur {$competitor2}",
    "name": "Welche Mannschaft trifft (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "421": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} ohne Gegentreffer (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "422": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} ohne Gegentreffer (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "423": {
    "1478": "{$competitor1} Tor & {$competitor1}",
    "1479": "{$competitor1} Tor & {$competitor2}",
    "1480": "{$competitor2} Tor & {$competitor1}",
    "1481": "{$competitor2} Tor & {$competitor2}",
    "name": "{!goalnr} Tor & Gewinner (inkl. OT und Elfmeterschießen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "424": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "Tipp & Über/Unter (inkl. OT und Elfmeterschießen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "425": {
    "1706": "{$competitor1} & ja",
    "1708": "{$competitor1} & nein",
    "1709": "{$competitor2} & ja",
    "1710": "{$competitor2} & nein",
    "name": "Tipp & Beide Mannschaften treffen (inkl. OT und Elfmeterschießen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "426": {
    "1482": "{$competitor1} & {$competitor1}",
    "1483": "X & {$competitor1}",
    "1484": "{$competitor2} & {$competitor1}",
    "1485": "{$competitor1} & {$competitor2}",
    "1486": "X & {$competitor2}",
    "1487": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} Periode Tipp & Gewinner (inkl. OT und Elfmeterschießen)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "427": {
    "1488": "1:0",
    "1489": "2:0",
    "1490": "3:0",
    "1491": "4:0",
    "1492": "5:0",
    "1493": "0:1",
    "1494": "2:1",
    "1495": "3:1",
    "1496": "4:1",
    "1497": "5:1",
    "1498": "0:2",
    "1499": "1:2",
    "1500": "3:2",
    "1501": "4:2",
    "1502": "5:2",
    "1503": "0:3",
    "1504": "1:3",
    "1505": "2:3",
    "1506": "4:3",
    "1507": "5:3",
    "1508": "0:4",
    "1509": "1:4",
    "1510": "2:4",
    "1511": "3:4",
    "1512": "5:4",
    "1513": "0:5",
    "1514": "1:5",
    "1515": "2:5",
    "1516": "3:5",
    "1517": "4:5",
    "1518": "andere",
    "name": "Genaues Ergebnis (inkl. OT und Elfmeterschießen)",
    "group": "all|score|incl_ot_and_pen"
  },
  "429": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & unentschieden",
    "1533": "X & unentschieden",
    "1534": "{$competitor2} & unentschieden",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} Periode Tipp & Tipp",
    "group": "all|regular_play|combo"
  },
  "430": {
    "1538": "0:0",
    "1539": "1:0",
    "1540": "2:0",
    "1541": "3:0",
    "1542": "4:0",
    "1543": "5:0",
    "1544": "6:0",
    "1545": "7:0",
    "1546": "8:0",
    "1547": "0:1",
    "1548": "1:1",
    "1549": "2:1",
    "1550": "3:1",
    "1551": "4:1",
    "1552": "5:1",
    "1553": "6:1",
    "1554": "7:1",
    "1555": "0:2",
    "1556": "1:2",
    "1557": "2:2",
    "1558": "3:2",
    "1559": "4:2",
    "1560": "5:2",
    "1561": "6:2",
    "1562": "0:3",
    "1563": "1:3",
    "1564": "2:3",
    "1565": "3:3",
    "1566": "4:3",
    "1567": "5:3",
    "1568": "0:4",
    "1569": "1:4",
    "1570": "2:4",
    "1571": "3:4",
    "1572": "4:4",
    "1573": "0:5",
    "1574": "1:5",
    "1575": "2:5",
    "1576": "3:5",
    "1577": "0:6",
    "1578": "1:6",
    "1579": "2:6",
    "1580": "0:7",
    "1581": "1:7",
    "1582": "0:8",
    "name": "Genaues Ergebnis {!score}",
    "group": "all|score|regular_play"
  },
  "431": {
    "1584": "0:0",
    "1585": "1:0",
    "1586": "2:0",
    "1587": "3:0",
    "1588": "4:0",
    "1589": "5:0",
    "1590": "0:1",
    "1591": "1:1",
    "1592": "2:1",
    "1593": "3:1",
    "1594": "4:1",
    "1595": "5:1",
    "1596": "0:2",
    "1597": "1:2",
    "1598": "2:2",
    "1599": "3:2",
    "1600": "4:2",
    "1601": "5:2",
    "1602": "0:3",
    "1603": "1:3",
    "1604": "2:3",
    "1605": "3:3",
    "1606": "4:3",
    "1607": "5:3",
    "1608": "0:4",
    "1609": "1:4",
    "1610": "2:4",
    "1611": "3:4",
    "1612": "4:4",
    "1613": "5:4",
    "1614": "0:5",
    "1615": "1:5",
    "1616": "2:5",
    "1617": "3:5",
    "1618": "4:5",
    "1619": "5:5",
    "1620": "andere",
    "name": "Genaues Ergebnis",
    "group": "all|score|regular_play"
  },
  "432": {
    "1621": "1. Periode",
    "1622": "2. Periode",
    "1623": "3. Periode",
    "1624": "gleich",
    "name": "Periode mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "433": {
    "1621": "1. Periode",
    "1622": "2. Periode",
    "1623": "3. Periode",
    "1624": "gleich",
    "name": "{$competitor1} Periode mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "434": {
    "1621": "1. Periode",
    "1622": "2. Periode",
    "1623": "3. Periode",
    "1624": "gleich",
    "name": "{$competitor2} Periode mit den meisten Toren",
    "group": "all|score|regular_play"
  },
  "435": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird alle Perioden gewinnen",
    "group": "all|score|regular_play"
  },
  "436": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird alle Perioden gewinnen",
    "group": "all|score|regular_play"
  },
  "437": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird irgendeine Periode gewinnen",
    "group": "all|score|regular_play"
  },
  "438": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird irgendeine Periode gewinnen",
    "group": "all|score|regular_play"
  },
  "439": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird in allen Perioden punkten",
    "group": "all|score|regular_play"
  },
  "440": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird in allen Perioden punkten",
    "group": "all|score|regular_play"
  },
  "441": {
    "74": "ja",
    "76": "nein",
    "name": "Alle Perioden {total} +",
    "group": "all|score|regular_play"
  },
  "442": {
    "74": "ja",
    "76": "nein",
    "name": "Alle Perioden {total} -",
    "group": "all|score|regular_play"
  },
  "443": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr} Periode - Tipp",
    "group": "all|score|period"
  },
  "444": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!periodnr} Periode - {!goalnr} Tor",
    "group": "all|score|period"
  },
  "445": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!periodnr} Periode - Handicap {hcp}",
    "group": "all|score|period"
  },
  "446": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} Periode - Über/Unter",
    "group": "all|score|period"
  },
  "447": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} Periode - {$competitor1} Über/Unter",
    "group": "all|score|period"
  },
  "448": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} Periode - {$competitor2} Über/Unter",
    "group": "all|score|period"
  },
  "452": {
    "74": "ja",
    "76": "nein",
    "name": "{!periodnr} Periode - Beide Mannschaften treffen",
    "group": "all|score|period"
  },
  "453": {
    "784": "keiner",
    "788": "nur {$competitor1}",
    "790": "nur {$competitor2}",
    "792": "beide Mannschaften",
    "name": "{!periodnr} Periode - Welche Mannschaft trifft",
    "group": "all|score|period"
  },
  "454": {
    "74": "ja",
    "76": "nein",
    "name": "{!periodnr} Periode - {$competitor1} ohne Gegentreffer",
    "group": "all|score|period"
  },
  "455": {
    "74": "ja",
    "76": "nein",
    "name": "{!periodnr} Periode - {$competitor2} ohne Gegentreffer",
    "group": "all|score|period"
  },
  "456": {
    "1630": "0:0",
    "1631": "1:0",
    "1632": "2:0",
    "1633": "0:1",
    "1634": "1:1",
    "1635": "2:1",
    "1636": "0:2",
    "1637": "1:2",
    "1638": "2:2",
    "1639": "andere",
    "name": "{!periodnr} Periode - Genaues Ergebnis",
    "group": "all|score|period"
  },
  "457": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!periodnr} Periode - Letzte Mannschaft trifft",
    "group": "all|score|period"
  },
  "458": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr} Periode- Wer gewinnt die verbleibende Spielzeit?",
    "group": "all|score|period"
  },
  "459": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!periodnr} Periode - unentschieden, keine Wette",
    "group": "all|score|period"
  },
  "460": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!periodnr} Periode - Handicap",
    "group": "all|score|period"
  },
  "462": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!periodnr} Periode - Gerade/ungerade",
    "group": "all|score|period"
  },
  "463": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "Verlängerung - Doppelte Chance",
    "group": "all|score|ot"
  },
  "464": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Verlängerung - unentschieden, keine Wette",
    "group": "all|score|ot"
  },
  "465": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "Verlängerung - {$competitor1} keine Wette",
    "group": "all|score|ot"
  },
  "466": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "Verlängerung - {$competitor2} keine Wette",
    "group": "all|score|ot"
  },
  "467": {
    "1640": "{$competitor1} mit Versuch",
    "1641": "{$competitor1} mit Strafstoß",
    "1642": "{$competitor1} mit Drop goal",
    "1643": "{$competitor2} mit Versuch",
    "1644": "{$competitor2} mit Strafstoß",
    "1645": "{$competitor2} mit Drop goal",
    "name": "{!scorenr} Scoring-Spiel",
    "group": "all|score|regular_play"
  },
  "472": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|1st_half"
  },
  "473": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Versuch Tipp",
    "group": "all|regular_play|tries"
  },
  "474": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "Versuch Doppelte Chance",
    "group": "all|regular_play|tries"
  },
  "475": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Versuch unentschieden, keine Wette",
    "group": "all|regular_play|tries"
  },
  "476": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Versuch Handicap {hcp}",
    "group": "all|regular_play|tries"
  },
  "477": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Versuch Handicap",
    "group": "all|regular_play|tries"
  },
  "478": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Versuche",
    "group": "all|regular_play|tries"
  },
  "479": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter Versuche",
    "group": "all|regular_play|tries"
  },
  "480": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter Versuche",
    "group": "all|regular_play|tries"
  },
  "481": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade Versuche",
    "group": "all|regular_play|tries"
  },
  "482": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1. HZ - Versuch Tipp",
    "group": "all|1st_half|tries"
  },
  "483": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "1. HZ - Versuch Doppelte Chance",
    "group": "all|1st_half|tries"
  },
  "484": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1. HZ - Versuch unentschieden, keine Wette",
    "group": "all|1st_half|tries"
  },
  "485": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1. HZ - Versuch Handicap {hcp}",
    "group": "all|1st_half|tries"
  },
  "486": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1. HZ - Versuch Handicap",
    "group": "all|1st_half|tries"
  },
  "487": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - Über/Unter Versuche",
    "group": "all|1st_half|tries"
  },
  "488": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor1} Über/Unter Versuche",
    "group": "all|1st_half|tries"
  },
  "489": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1. HZ - {$competitor2} Über/Unter Versuche",
    "group": "all|1st_half|tries"
  },
  "490": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. HZ - Gerade/ungerade Versuche",
    "group": "all|1st_half|tries"
  },
  "491": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Welcher Spieler gewinnt die verbleibende Spielzeit?",
    "group": "all|score|regular_play"
  },
  "492": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein entscheidendes Frame geben?",
    "group": "all|score|regular_play"
  },
  "493": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Frame Handicap",
    "group": "all|score|regular_play"
  },
  "494": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Frames",
    "group": "all|score|regular_play"
  },
  "495": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Gerade/ungerade Frames",
    "group": "all|score|regular_play"
  },
  "496": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst {framenr} Frames?",
    "group": "all|score|regular_play"
  },
  "497": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Frames {fromframe} bis {toframe} - {frames} aufeinanderfolgendes Frames Gewinner",
    "group": "all|score|x_frames"
  },
  "498": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Frames 1 zu {framenr} - Tipp",
    "group": "all|score|x_frames"
  },
  "499": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} Frame - Gewinner",
    "group": "all|score|frame"
  },
  "500": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!framenr} Frame - Punkte Handicap",
    "group": "all|score|frame"
  },
  "501": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!framenr} Frame - Anzahl Punkte",
    "group": "all|score|frame"
  },
  "502": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!framenr} Frame - Gerade/ungerade",
    "group": "all|score|frame"
  },
  "503": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} Frame - Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|frame"
  },
  "504": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} Frame - Spieler mit dem höchsten Break",
    "group": "all|frame|break"
  },
  "505": {
    "1667": "0-49",
    "1668": "50-99",
    "1669": "100-119",
    "1670": "120-146",
    "1671": "147+",
    "name": "{!framenr} Frame - Höchstes Break",
    "group": "all|frame|break"
  },
  "506": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - Break 100+",
    "group": "all|frame|break"
  },
  "507": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - {$competitor1} Break 100+",
    "group": "all|frame|break"
  },
  "508": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - {$competitor2} Break 100+",
    "group": "all|frame|break"
  },
  "509": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - Break 50+",
    "group": "all|frame|break"
  },
  "510": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - {$competitor1} Break 50+",
    "group": "all|frame|break"
  },
  "511": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - {$competitor2} Break 50+",
    "group": "all|frame|break"
  },
  "512": {
    "74": "ja",
    "76": "nein",
    "name": "{!framenr} Frame - Wird es ein Foul geben?",
    "group": "all|score|frame"
  },
  "513": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} Frame - Spieler locht {!xth} Ball ein",
    "group": "all|score|frame"
  },
  "514": {
    "1672": "Gelb",
    "1673": "Grün",
    "1674": "Braun",
    "1675": "Blau",
    "1676": "Pink",
    "1677": "Schwarz",
    "name": "{!framenr} Frame - {!xth} Farbe eingelocht",
    "group": "all|score|frame"
  },
  "515": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} Frame - Spieler locht letzte Kugel ein",
    "group": "all|score|frame"
  },
  "516": {
    "1678": "Rot",
    "1679": "Gelb",
    "1680": "Grün",
    "1681": "Braun",
    "1682": "Blau",
    "1683": "Pink",
    "1684": "Schwarz",
    "1685": "Foul",
    "name": "{!framenr} Frame - Zuletzt erzielte Punkte",
    "group": "all|score|frame"
  },
  "520": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} Spiel - {!pointnr} Punkt",
    "group": "all|score|game"
  },
  "525": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es einen 4ten Satz geben?",
    "group": "all|score|regular_play"
  },
  "526": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es einen 5ten Satz geben?",
    "group": "all|score|regular_play"
  },
  "527": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} Satz - Handicap",
    "group": "all|score|set"
  },
  "528": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - Über/Unter",
    "group": "all|score|set"
  },
  "529": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "{!periodnr} Periode - Doppelte Chance",
    "group": "all|score|period"
  },
  "530": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - {!scorenr} Ergebnis",
    "group": "all"
  },
  "538": {
    "1717": "X",
    "name": "Head2head (Tipp)",
    "group": "all"
  },
  "540": {
    "1718": "{$competitor1}/X & ja",
    "1719": "{$competitor1}/X & nein",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nein",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nein",
    "name": "Doppelte Chance (Spiel) & 1. HZ Beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "541": {
    "1718": "{$competitor1}/X & ja",
    "1719": "{$competitor1}/X & nein",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nein",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nein",
    "name": "Doppelte Chance (Spiel) & 2. HZ Beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "542": {
    "1718": "{$competitor1}/X & ja",
    "1719": "{$competitor1}/X & nein",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nein",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nein",
    "name": "1. HZ - Doppelte Chance & Beide Mannschaften treffen",
    "group": "all|combo|1st_half"
  },
  "543": {
    "78": "{$competitor1} & ja",
    "80": "{$competitor1} & nein",
    "82": "X & ja",
    "84": "X & nein",
    "86": "{$competitor2} & ja",
    "88": "{$competitor2} & nein",
    "name": "2. HZ - Tipp & Beide Mannschaften treffen",
    "group": "all|combo|2nd_half"
  },
  "544": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "2. HZ - Tipp & Über/Unter",
    "group": "all|combo|2nd_half"
  },
  "545": {
    "1718": "{$competitor1}/X & ja",
    "1719": "{$competitor1}/X & nein",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nein",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nein",
    "name": "2. HZ - Doppelte Chance & Beide Mannschaften treffen",
    "group": "all|combo|2nd_half"
  },
  "546": {
    "1718": "{$competitor1}/X & ja",
    "1719": "{$competitor1}/X & nein",
    "1720": "{$competitor1}/{$competitor2} & ja",
    "1721": "{$competitor1}/{$competitor2} & nein",
    "1722": "X/{$competitor2} & ja",
    "1723": "X/{$competitor2} & nein",
    "name": "Doppelte Chance & Beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "547": {
    "1724": "{$competitor1}/X & {total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "X/{$competitor2} & {total} -",
    "1727": "{$competitor1}/X & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "X/{$competitor2} & {total} +",
    "name": "Doppelte Chance & Über/Unter",
    "group": "all|regular_play|combo"
  },
  "548": {
    "1730": "1-2",
    "1731": "1-3",
    "1732": "1-4",
    "1733": "1-5",
    "1734": "1-6",
    "1735": "2-3",
    "1736": "2-4",
    "1737": "2-5",
    "1738": "2-6",
    "1739": "3-4",
    "1740": "3-5",
    "1741": "3-6",
    "1742": "4-5",
    "1743": "4-6",
    "1744": "5-6",
    "1745": "7+",
    "1804": "kein Tor",
    "name": "Gesamtzahl der Tore im Spiel",
    "group": "all|score|regular_play"
  },
  "549": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "kein Tor",
    "name": "{$competitor1} Gesamtzahl der Tore im Spiel",
    "group": "all|score|regular_play"
  },
  "550": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "kein Tor",
    "name": "{$competitor2} Gesamtzahl der Tore im Spiel",
    "group": "all|score|regular_play"
  },
  "551": {
    "1750": "1:0, 2:0 oder 3:0",
    "1751": "0:1, 0:2 oder 0:3",
    "1752": "4:0, 5:0 oder 6:0",
    "1753": "0:4, 0:5 oder 0:6",
    "1754": "2:1, 3:1 oder 4:1",
    "1755": "1:2, 1:3 oder 1:4",
    "1756": "3:2, 4:2, 4:3 oder 5:1",
    "1757": "2:3, 2:4, 3:4 oder 1:5",
    "1758": "andere Sieg Heimmannschaft",
    "1759": "andere Sieg Auswärtsmannschaft",
    "1803": "X",
    "name": "Endergebnis",
    "group": "all|score|regular_play"
  },
  "552": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "kein Tor",
    "name": "1. HZ - Gesamtzahl der Tore im Spiel",
    "group": "all|score|1st_half"
  },
  "553": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "kein Tor",
    "name": "2. HZ - Gesamtzahl der Tore im Spiel",
    "group": "all|score|2nd_half"
  },
  "554": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Kill unentschieden, keine Wette",
    "group": "all|kills|map"
  },
  "555": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} Map - Kill Handicap",
    "group": "all|kills|map"
  },
  "556": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Drache",
    "group": "all|map|structures"
  },
  "557": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Baron",
    "group": "all|map|structures"
  },
  "558": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Inhibitor",
    "group": "all|map|structures"
  },
  "563": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|regular_play"
  },
  "565": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 Minuten - Ecken Tipp von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "566": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "15 Minuten - {!cornernr} Ecke von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "567": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "15 Minuten - Ecken Handicap von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "568": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 Minuten - Über/Unter Ecken von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "569": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 Minuten - {$competitor1} Über/Unter Ecken von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "570": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 Minuten - {$competitor2} Über/Unter Ecken von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "571": {
    "70": "ungerade",
    "72": "gerade",
    "name": "15 Minuten - Gerade/ungerade Ecken von {from} bis {to}",
    "group": "all|15_min|corners"
  },
  "572": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 Minuten - Ecken Tipp von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "573": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "10 Minuten - {!cornernr} Ecke von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "574": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "10 Minuten - Ecken Handicap von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "575": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 Minuten - Über/Unter Ecken von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "576": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 Minuten - {$competitor1} Über/Unter Ecken von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "577": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 Minuten - {$competitor2} Über/Unter Ecken von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "578": {
    "70": "ungerade",
    "72": "gerade",
    "name": "10 Minuten - Gerade/ungerade Ecken von {from} bis {to}",
    "group": "all|10_min|corners"
  },
  "579": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 Minuten - Ecken Tipp von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "580": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "5 Minuten - {!cornernr} Ecke von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "581": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "5 Minuten - Ecken Handicap von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "582": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 Minuten - Über/Unter Ecken von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "583": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 Minuten - {$competitor1} Über/Unter Ecken von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "584": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 Minuten - {$competitor2} Über/Unter Ecken von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "585": {
    "70": "ungerade",
    "72": "gerade",
    "name": "5 Minuten - Gerade/ungerade Ecken von {from} bis {to}",
    "group": "all|5_min|corners"
  },
  "586": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 Minuten - Karten Tipp von {from} bis {to}",
    "group": "all|15_min|bookings"
  },
  "587": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 Minuten - Über/Unter Karten von {from} bis {to}",
    "group": "all|15_min|bookings"
  },
  "588": {
    "74": "ja",
    "76": "nein",
    "name": "15 Minuten - Platzverweise von {from} bis {to}",
    "group": "all|15_min|bookings"
  },
  "589": {
    "74": "ja",
    "76": "nein",
    "name": "15 Minuten - {$competitor1} Platzverweise from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "590": {
    "74": "ja",
    "76": "nein",
    "name": "15 Minuten - {$competitor2} Platzverweise von {from} bis {to}",
    "group": "all|15_min|bookings"
  },
  "591": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 Minuten - Karten Tipp von {from} bis {to}",
    "group": "all|10_min|bookings"
  },
  "592": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 Minuten - Über/Unter Karten von {from} bis {to}",
    "group": "all|10_min|bookings"
  },
  "593": {
    "74": "ja",
    "76": "nein",
    "name": "10 Minuten - Platzverweise von {from} bis {to}",
    "group": "all|10_min|bookings"
  },
  "594": {
    "74": "ja",
    "76": "nein",
    "name": "10 Minuten - {$competitor1} Platzverweise from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "595": {
    "74": "ja",
    "76": "nein",
    "name": "10 Minuten - {$competitor2} Platzverweise von {from} bis {to}",
    "group": "all|10_min|bookings"
  },
  "596": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 Minuten - Karten Tipp von {from} bis {to}",
    "group": "all|5_min|bookings"
  },
  "597": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 Minuten - Über/Unter Karten von {from} bis {to}",
    "group": "all|5_min|bookings"
  },
  "598": {
    "74": "ja",
    "76": "nein",
    "name": "5 Minuten - Platzverweise von {from} bis {to}",
    "group": "all|5_min|bookings"
  },
  "599": {
    "74": "ja",
    "76": "nein",
    "name": "5 Minuten - {$competitor1} Platzverweise von {from} bis {to}",
    "group": "all|5_min|bookings"
  },
  "600": {
    "74": "ja",
    "76": "nein",
    "name": "5 Minuten - {$competitor2} Platzverweise von {from} bis {to}",
    "group": "all|5_min|bookings"
  },
  "601": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Wer erreicht zuerst {cornernr} Ecken",
    "group": "all|regular_play|corners"
  },
  "602": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - Wer erreicht zuerst {cornernr} Ecken",
    "group": "all|1st_half|corners"
  },
  "603": {
    "1797": "oben links",
    "1798": "unten links",
    "1799": "oben Mitte",
    "1800": "unten Mitte",
    "1801": "oben rechts",
    "1802": "unten rechts",
    "name": "{!goalnr} Tor - Schlagzone",
    "group": "all|misc"
  },
  "604": {
    "74": "ja",
    "76": "nein",
    "name": "{!penaltynr} Elfmeter verwandelt",
    "group": "all|score|regular_play"
  },
  "605": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning – Über/Unter",
    "group": "all|score|innings"
  },
  "606": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning – {$competitor1} Über/Unter",
    "group": "all|score|innings"
  },
  "607": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning – {$competitor2} Über/Unter",
    "group": "all|score|innings"
  },
  "608": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!inningnr} Inning – Gerade/ungerade",
    "group": "all|score|innings"
  },
  "609": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Welches Team gewinnt das Viertel mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "610": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Tipp (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "611": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} Viertel - Tipp (inkl. OT)",
    "group": "all|score|quarter_incl_ot"
  },
  "612": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "unentschieden, keine Wette (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "613": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} Viertel - unentschieden, keine Wette (inkl. OT)",
    "group": "all|score|quarter_incl_ot"
  },
  "614": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} Viertel - Handicap (inkl. OT)",
    "group": "all|score|quarter_incl_ot"
  },
  "615": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} Viertel - Über/Unter (inkl. OT)",
    "group": "all|score|quarter_incl_ot"
  },
  "616": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{$competitor1} Gerade/ungerade (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "617": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{$competitor2} Gerade/ungerade (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "618": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. HZ - {$competitor1} Gerade/ungerade",
    "group": "all|score|1st_half"
  },
  "619": {
    "70": "ungerade",
    "72": "gerade",
    "name": "1. HZ - {$competitor2} Gerade/ungerade",
    "group": "all|score|1st_half"
  },
  "620": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Wer erreicht zuerst {roundnr} Runden",
    "group": "all|score|map"
  },
  "621": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!mapnr} Map - Gerade/ungerade Runden (inkl. OT)",
    "group": "all|score|map_incl_ot"
  },
  "622": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map - Über/Unter Kopfschüsse (inkl. OT)",
    "group": "all|map_incl_ot|kills"
  },
  "623": {
    "74": "ja",
    "76": "nein",
    "name": "{!mapnr} Map - Wird es ein Ace geben (inkl. OT)",
    "group": "all|map_incl_ot|kills"
  },
  "626": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map Runde {roundnr} - Über/Unter Kills",
    "group": "all|kills|round"
  },
  "627": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} Map Runde {roundnr} - Kill Handicap",
    "group": "all|kills|round"
  },
  "628": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map Runde {roundnr} - {!killnr} Kill",
    "group": "all|kills|round"
  },
  "629": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map Runde {roundnr} - {$competitor1} Über/Unter Kills",
    "group": "all|kills|round"
  },
  "630": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map Runde {roundnr} - {$competitor2} Über/Unter Kills",
    "group": "all|kills|round"
  },
  "631": {
    "74": "ja",
    "76": "nein",
    "name": "{!mapnr} Map Runde {roundnr} - Bombe platziert",
    "group": "all|round|bomb"
  },
  "632": {
    "74": "ja",
    "76": "nein",
    "name": "{!mapnr} Map Runde {roundnr} - Bombe entschärft",
    "group": "all|round|bomb"
  },
  "634": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Welches Team gewinnt die HZ mit den meisten Punkten",
    "group": "all|score|regular_play"
  },
  "638": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Gesamt",
    "group": "all"
  },
  "639": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Fours Gesamt",
    "group": "all"
  },
  "640": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Sixes Gesamt",
    "group": "all"
  },
  "641": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor1} Dismissal",
    "group": "all"
  },
  "642": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} Dismissal",
    "group": "all"
  },
  "643": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Fours gesamt",
    "group": "all"
  },
  "644": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Sixes gesamt",
    "group": "all"
  },
  "645": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning Over {overnr} - Tipp",
    "group": "all"
  },
  "646": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team mit höchster Punktzahl {!dismissalnr} Dismissal",
    "group": "all"
  },
  "647": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Fours",
    "group": "all"
  },
  "648": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Sixes",
    "group": "all"
  },
  "649": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Dismissals Gesamt",
    "group": "all"
  },
  "650": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Dismissals Gesamt",
    "group": "all"
  },
  "651": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Inning - {%player} Dismissal Methode",
    "group": "all"
  },
  "652": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor1} Boundary",
    "group": "all"
  },
  "653": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} Boundary",
    "group": "all"
  },
  "654": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Run outs gesamt",
    "group": "all"
  },
  "655": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Extras gesamt",
    "group": "all"
  },
  "656": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "{!inningnr} Inning - {!dismissalnr} Partnerschaft Tipp",
    "group": "all"
  },
  "657": {
    "1821": "{%player1}",
    "1822": "{%player2}",
    "name": "{!inningnr} Inning - {!dismissalnr} Batter out",
    "group": "all"
  },
  "658": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Fours gesamt",
    "group": "all"
  },
  "659": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Fours gesamt",
    "group": "all"
  },
  "660": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Sixes gesamt",
    "group": "all"
  },
  "661": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Sixes gesamt",
    "group": "all"
  },
  "662": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {%player} erzielt {milestone}",
    "group": "all"
  },
  "663": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Overs null zu {overnr} - {$competitor1} Dismissals gesamt",
    "group": "all"
  },
  "664": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning Overs null zu {overnr} - {$competitor2} Dismissals gesamt",
    "group": "all"
  },
  "665": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!daynr} Tagessession {sessionnr} - Über/Unter",
    "group": "all"
  },
  "666": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Extras gesamt",
    "group": "all"
  },
  "667": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Extras gesamt",
    "group": "all"
  },
  "668": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Run outs gesamt",
    "group": "all"
  },
  "669": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Run outs gesamt",
    "group": "all"
  },
  "670": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter im Over mit dem höchsten Score",
    "group": "all"
  },
  "671": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter im Over mit dem höchsten Score",
    "group": "all"
  },
  "680": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Extras",
    "group": "all"
  },
  "681": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Run outs",
    "group": "all"
  },
  "682": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter im Over mit dem höchsten Score",
    "group": "all"
  },
  "686": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Batter head2head (Tipp)",
    "group": "all"
  },
  "687": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Bowler head2head (Tipp)",
    "group": "all"
  },
  "688": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "All-rounder head2head (Tipp)",
    "group": "all"
  },
  "689": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Torwächter head2head (Tipp)",
    "group": "all"
  },
  "690": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!inningnr} Inning - {$competitor1} Gerade/ungerade",
    "group": "all"
  },
  "691": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{!inningnr} Inning - {$competitor2} Gerade/ungerade",
    "group": "all"
  },
  "692": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor1} beendet mit einem Boundary",
    "group": "all"
  },
  "693": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor2} beendet mit einem Boundary",
    "group": "all"
  },
  "694": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Welches Team gewinnt den Münzwurf",
    "group": "all"
  },
  "695": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Ducks gesamt",
    "group": "all"
  },
  "696": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Wides gesamt",
    "group": "all"
  },
  "697": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Dismissals Gesamt",
    "group": "all"
  },
  "698": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Mannschaft mit dem besten Batter",
    "group": "all"
  },
  "699": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Mannschaft mit dem besten Bowler",
    "group": "all"
  },
  "700": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - Jeder Spieler erzielt {milestone}",
    "group": "all"
  },
  "701": {
    "74": "ja",
    "76": "nein",
    "name": "Jeder Spieler erzielt {milestone}",
    "group": "all"
  },
  "702": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Bester Batter gesamt",
    "group": "all"
  },
  "703": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rabbit gesamt",
    "group": "all"
  },
  "704": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings - {$competitor1} Wides gesamt gebowled",
    "group": "all"
  },
  "705": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings - {$competitor2} Wides gesamt gebowled",
    "group": "all"
  },
  "706": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Ducks gesamt",
    "group": "all"
  },
  "707": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Ducks gesamt",
    "group": "all"
  },
  "708": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Dismissals gesamt",
    "group": "all"
  },
  "709": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Gesamtspielerleistung",
    "group": "all"
  },
  "710": {
    "1813": "{$competitor1}",
    "1814": "weder noch",
    "1815": "{$competitor2}",
    "name": "Welches Team gewinnt den Münzwurf und das Spiel",
    "group": "all"
  },
  "711": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning - Tipp",
    "group": "all"
  },
  "712": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meisten Torwächter-Paraden",
    "group": "all"
  },
  "713": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Paraden",
    "group": "all"
  },
  "714": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Meiste Stumpings",
    "group": "all"
  },
  "717": {
    "1816": "{%player1} ({+hcp})",
    "1817": "{%player2} ({-hcp})",
    "name": "Batter head2head (Handicap)",
    "group": "all"
  },
  "718": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Inning - {!dismissalnr} Dismissal Methode (erweitert)",
    "group": "all"
  },
  "723": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Rampage geben",
    "group": "all|regular_play|kills"
  },
  "724": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Ultra-Kill geben",
    "group": "all|regular_play|kills"
  },
  "725": {
    "1831": "00:00 - {(minute-1)}:59",
    "1832": "{minute}:00+",
    "name": "{!mapnr} Map - Dauer",
    "group": "all|map|progress"
  },
  "726": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map - Kills gesamt",
    "group": "all|kills|map"
  },
  "727": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map - Aegis gesamt",
    "group": "all|map|structures"
  },
  "728": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map - Towers gesamt",
    "group": "all|map|structures"
  },
  "729": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} Map - Aegis Handicap",
    "group": "all|map|structures"
  },
  "730": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} Map - Tower Handicap",
    "group": "all|map|structures"
  },
  "731": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Wer erreicht zuerst {xth} Kills",
    "group": "all|kills|map"
  },
  "732": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Wer erreicht zuerst {xth} Net worth",
    "group": "all|map|progress"
  },
  "733": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Wer erreicht zuerst Level {xth}",
    "group": "all|map|progress"
  },
  "734": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} Map 10 Minuten - Kills von {from} bis {to} gesamt",
    "group": "all|10_min|kills"
  },
  "736": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map 1te Hälfte - Sieger",
    "group": "all|score|map_1st_half"
  },
  "737": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Maximale aufeinanderfolgende Läufe von beiden Teams",
    "group": "all|score|regular_play"
  },
  "738": {
    "1823": "Anfang des 9. Innings",
    "1824": "Ende des 9. Innings",
    "1825": "jedes zusätzliches Inning",
    "name": "Wann wird das Spiel entschieden werden",
    "group": "all|score|regular_play"
  },
  "739": {
    "1826": "{!inningnr} Inning",
    "1828": "{!(inningnr+1)} Inning",
    "1829": "{!(inningnr+2)} Inning",
    "1830": "Anderes Inning oder kein Lauf",
    "name": "Wann wird der {!runnr} Run erzielt (inkl. Extra-Innings)",
    "group": "all|score|incl_ei"
  },
  "740": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Torlose Innings gesamt",
    "group": "all|score|regular_play"
  },
  "741": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Mannschaften {total} + (inkl. Extra-Innings)",
    "group": "all|score|incl_ei"
  },
  "742": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & unentschieden",
    "1533": "X & unentschieden",
    "1534": "{$competitor2} & unentschieden",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "Erste {innings} Innings Tipp & Tipp (inkl. Extra-Innings)",
    "group": "all|combo|incl_ei"
  },
  "743": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings {from} bis {to} - Tipp",
    "group": "all|score|3_innings"
  },
  "744": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings {from} bis {to} - Handicap",
    "group": "all|score|3_innings"
  },
  "745": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Inning {from} bis {to} - Gerade/ungerade",
    "group": "all|score|3_innings"
  },
  "746": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!inningnr} Inning - Handicap",
    "group": "all|score|inning"
  },
  "747": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter",
    "group": "all|score|inning"
  },
  "748": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter",
    "group": "all|score|inning"
  },
  "749": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor1} punktet",
    "group": "all|score|inning"
  },
  "750": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor2} punktet",
    "group": "all|score|inning"
  },
  "751": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - Beide Mannschaften treffen",
    "group": "all|score|inning"
  },
  "752": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - {!xth} Shrine",
    "group": "all|map|structures"
  },
  "753": {
    "9": "{$competitor1} oder X",
    "10": "{$competitor1} oder {$competitor2}",
    "11": "X oder {$competitor2}",
    "name": "{!quarternr} Viertel - Doppelte Chance",
    "group": "all|score|quarter"
  },
  "754": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} Viertel - Wer gewinnt die verbleibende Spielzeit?",
    "group": "all|score|quarter"
  },
  "756": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} Viertel - {$competitor1} Über/Unter",
    "group": "all|score|quarter"
  },
  "757": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} Viertel - {$competitor2} Über/Unter",
    "group": "all|score|quarter"
  },
  "797": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Heimmannschaften Über/Unter",
    "group": "all|matchday"
  },
  "798": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Auswärtsmannschaften Über/Unter",
    "group": "all|matchday"
  },
  "799": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Über/Unter",
    "group": "all|matchday"
  },
  "800": {
    "1833": "Heimmannschaften",
    "1834": "X",
    "1835": "Auswärtsmannschaften",
    "name": "{$event} Spieltag {matchday} - Meiste Tore Heim- oder Auswärtsmannschaften",
    "group": "all|matchday"
  },
  "801": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Siege Heimmannschaften Gesamt",
    "group": "all|matchday"
  },
  "802": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Unentschieden Gesamt",
    "group": "all|matchday"
  },
  "803": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} Spieltag {matchday} - Siege Auswärtsmannschaften Gesamt",
    "group": "all|matchday"
  },
  "815": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} Map - Assist keine Wette",
    "group": "all"
  },
  "816": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Innings - {$competitor1} {!dismissalnr} Dismissal Methode (erweitert)",
    "group": "all"
  },
  "817": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Innings - {$competitor2} {!dismissalnr} Dismissal Methode (erweitert)",
    "group": "all"
  },
  "818": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/X & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "unentschieden /{$competitor1} & {total} -",
    "1840": "X/X & {total} -",
    "1841": "X/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/X & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & {total} +",
    "1846": "{$competitor1}/X & {total} +",
    "1847": "{$competitor1}/{$competitor2} & {total} +",
    "1848": "X/{$competitor1} & {total} +",
    "1849": "X/X & {total} +",
    "1850": "X/{$competitor2} & {total} +",
    "1851": "{$competitor2}/{$competitor1} & {total} +",
    "1852": "{$competitor2}/X & {total} +",
    "1853": "{$competitor2}/{$competitor2} & {total} +",
    "name": "HZ/reg. Spielzeit & Über/Unter",
    "group": "all|regular_play|combo"
  },
  "819": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/X & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "unentschieden /{$competitor1} & {total} -",
    "1840": "X/X & {total} -",
    "1841": "X/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/X & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & {total} +",
    "1846": "{$competitor1}/X & {total} +",
    "1847": "{$competitor1}/{$competitor2} & {total} +",
    "1848": "X/{$competitor1} & {total} +",
    "1849": "X/X & {total} +",
    "1850": "X/{$competitor2} & {total} +",
    "1851": "{$competitor2}/{$competitor1} & {total} +",
    "1852": "{$competitor2}/X & {total} +",
    "1853": "{$competitor2}/{$competitor2} & {total} +",
    "name": "HZ/reg. Spielzeit & Über/Unter 1. Hälfte",
    "group": "all|regular_play|combo"
  },
  "820": {
    "1854": "X/X & 0",
    "1855": "{$competitor1}/{$competitor1} & 1",
    "1856": "X/{$competitor1} & 1",
    "1857": "X/{$competitor2} & 1",
    "1858": "{$competitor2}/{$competitor2} & 1",
    "1859": "{$competitor1}/{$competitor1} & 2",
    "1860": "{$competitor1}/X & 2",
    "1861": "X/{$competitor1} & 2",
    "1862": "X/X& 2",
    "1863": "X/{$competitor2} & 2",
    "1864": "{$competitor2}/X & 2",
    "1865": "{$competitor2}/{$competitor2} & 2",
    "1866": "{$competitor1}/{$competitor1} & 3",
    "1867": "{$competitor1}/{$competitor2} & 3",
    "1868": "X/{$competitor1} & 3",
    "1869": "X/{$competitor2} & 3",
    "1870": "{$competitor2}/{$competitor1} & 3",
    "1871": "{$competitor2}/{$competitor2} & 3",
    "1872": "{$competitor1}/{$competitor1} & 4",
    "1873": "{$competitor1}/X & 4",
    "1874": "{$competitor1}/{$competitor2} & 4",
    "1875": "X/{$competitor1} & 4",
    "1876": "X/X& 4",
    "1877": "X/{$competitor2} & 4",
    "1878": "{$competitor2}/{$competitor1} & 4",
    "1879": "{$competitor2}/X & 4",
    "1880": "{$competitor2}/{$competitor2} & 4",
    "1881": "{$competitor1}/{$competitor1} & 5+",
    "1882": "{$competitor1}/X & 5+",
    "1883": "{$competitor1}/{$competitor2} & 5+",
    "1884": "X/{$competitor1} & 5+",
    "1885": "X/X& 5+",
    "1886": "X/{$competitor2} & 5+",
    "1887": "{$competitor2}/{$competitor1} & 5+",
    "1888": "{$competitor2}/X & 5+",
    "1889": "{$competitor2}/{$competitor2} & 5+",
    "name": "HZ/reg. Spielzeit & Genaue Anzahl Tore",
    "group": "all|regular_play|combo"
  },
  "821": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Unentschieden Summe ungerade/gerade",
    "group": "all"
  },
  "822": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Unentschieden Summe Über/Unter",
    "group": "all"
  },
  "824": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Zusatzzahl ungerade/gerade",
    "group": "all"
  },
  "825": {
    "70": "ungerade",
    "72": "gerade",
    "name": "Zusatzzahl Summe ungerade/gerade",
    "group": "all"
  },
  "826": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Zusatzzahl insgesamt",
    "group": "all"
  },
  "827": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Zusatzzahl Summe insgesamt",
    "group": "all"
  },
  "828": {
    "74": "ja",
    "76": "nein",
    "name": "Zustzzahl einstellig",
    "group": "all"
  },
  "829": {
    "74": "ja",
    "76": "nein",
    "name": "Zusatzzahl entspricht einer regulären Zahl",
    "group": "all"
  },
  "831": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Gezogene Summe insgesamt (inkl. Zusatzzahl)",
    "group": "all"
  },
  "835": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor1} windex",
    "group": "all"
  },
  "836": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor2} windex",
    "group": "all"
  },
  "837": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor1}/{$competitor2} Vormachtstellung",
    "group": "all"
  },
  "838": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor2}/{$competitor1} Vormachtstellung",
    "group": "all"
  },
  "839": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter Spread",
    "group": "all"
  },
  "840": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Spread",
    "group": "all"
  },
  "841": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter Spread at {!dismissalnr} Dismissal",
    "group": "all"
  },
  "842": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Spread beim {!dismissalnr} Dismissal",
    "group": "all"
  },
  "843": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {%player} Über/Unter Spread",
    "group": "all"
  },
  "844": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs 0 bis {overnr} - {$competitor1} Über/Unter Spread",
    "group": "all"
  },
  "845": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs 0 bis {overnr} - {$competitor2} Über/Unter Spread",
    "group": "all"
  },
  "846": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Innings Over {overnr} - {$competitor1} Über/Unter Spread",
    "group": "all"
  },
  "847": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} Über/Unter Spread",
    "group": "all"
  },
  "850": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird genau einen Satz gewinnen",
    "group": "all|score|regular_play"
  },
  "851": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird genau einen Satz gewinnen",
    "group": "all|score|regular_play"
  },
  "852": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird genau zwei Sätze gewinnen",
    "group": "all|score|regular_play"
  },
  "853": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird genau zwei Sätze gewinnen",
    "group": "all|score|regular_play"
  },
  "854": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} oder {total} +",
    "group": "all|regular_play|combo"
  },
  "855": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} oder {total} -",
    "group": "all|regular_play|combo"
  },
  "856": {
    "74": "ja",
    "76": "nein",
    "name": "Gleichstand oder {total} +",
    "group": "all|regular_play|combo"
  },
  "857": {
    "74": "ja",
    "76": "nein",
    "name": "Gleichstand oder {total} -",
    "group": "all|regular_play|combo"
  },
  "858": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} oder {total} +",
    "group": "all|regular_play|combo"
  },
  "859": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} oder {total} -",
    "group": "all|regular_play|combo"
  },
  "860": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} oder beide Teams werden punkten",
    "group": "all|regular_play|combo"
  },
  "861": {
    "74": "ja",
    "76": "nein",
    "name": "X oder beide Mannschaften treffen",
    "group": "all|regular_play|combo"
  },
  "862": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} oder beide Teams werden punkten",
    "group": "all|regular_play|combo"
  },
  "863": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} oder jemand ohne Gegentreffer",
    "group": "all|regular_play|combo"
  },
  "864": {
    "74": "ja",
    "76": "nein",
    "name": "X oder jemand ohne Gegentreffer",
    "group": "all|regular_play|combo"
  },
  "865": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} oder jemand ohne Gegentreffer",
    "group": "all|regular_play|combo"
  },
  "870": {
    "1893": "Andere",
    "name": "Exacta",
    "group": "all"
  },
  "871": {
    "1893": "Andere",
    "name": "Quinella",
    "group": "all"
  },
  "872": {
    "1893": "Andere",
    "name": "Trifecta",
    "group": "all"
  },
  "873": {
    "1893": "Andere",
    "name": "Trio",
    "group": "all"
  },
  "875": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter am {!dismissalnr} Dismissal",
    "group": "all"
  },
  "876": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter at {!dismissalnr} Dismissal",
    "group": "all"
  },
  "877": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Innings - {$competitor1} insgesamt",
    "group": "all"
  },
  "878": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Innings - {$competitor2} insgesamt",
    "group": "all"
  },
  "879": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} wird gewinnen",
    "group": "all|score|regular_play"
  },
  "880": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} wird gewinnen",
    "group": "all|score|regular_play"
  },
  "881": {
    "74": "ja",
    "76": "nein",
    "name": "Eines der Teams gewinnt",
    "group": "all|score|regular_play"
  },
  "882": {
    "74": "ja",
    "76": "nein",
    "name": "{%player} wird punkten (inkl. OT)",
    "group": "all|scorers|incl_ot"
  },
  "883": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 Minute - insgesamt von {from} bis {to}",
    "group": "all|score|rapid_market"
  },
  "884": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 Minute - insgesamte Ecken von {from} bis {to}",
    "group": "all|corners|rapid_market"
  },
  "885": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 Minute - insgesamte Karten von {from} bis {to}",
    "group": "all|bookings|rapid_market"
  },
  "886": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 Minute - insgesamte Abseits von {from} bis {to}",
    "group": "all|rapid_market|offsides"
  },
  "887": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 Minute - insgesamte Strafstöße von {from} bis {to}",
    "group": "all|rapid_market|penalties"
  },
  "888": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & unentschieden",
    "1896": "{%player} & {$competitor2}",
    "1897": "andere",
    "name": "Torschütze(n) & Tipp",
    "group": "all|regular_play|combo"
  },
  "889": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "andere",
    "name": "Torschütze(n) & richtiger Punktestand",
    "group": "all|regular_play|combo"
  },
  "890": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "andere",
    "name": "{!goalnr} Torschütze & richtiger Punktestand",
    "group": "all|regular_play|combo"
  },
  "891": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & unentschieden",
    "1896": "{%player} & {$competitor2}",
    "1897": "andere",
    "name": "{!goalnr} Torschütze & Tipp",
    "group": "all|regular_play|combo"
  },
  "894": {
    "1923": "7:0",
    "1924": "7:1",
    "1925": "7:2",
    "1926": "7:3",
    "1927": "7:4",
    "1928": "7:5",
    "1929": "Andere {$competitor1} Sieg",
    "1930": "0:7",
    "1931": "1:7",
    "1932": "2:7",
    "1933": "3:7",
    "1934": "4:7",
    "1935": "5:7",
    "1936": "Andere {$competitor2} Sieg",
    "name": "{!setnr} Satz tiebreak - richtiger Punktestand",
    "group": "all|score|tiebreak"
  },
  "895": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz tiebreak - insgesamter Punktestand",
    "group": "all|score|tiebreak"
  },
  "896": {
    "1937": "Schuss",
    "1938": "Header",
    "1939": "Eigentor",
    "1940": "Strafestoß",
    "1941": "Freistoß",
    "1942": "Keiner",
    "name": "{!scorenr} Score-Typ",
    "group": "all|score|regular_play"
  },
  "897": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "andere",
    "name": "Verlängerung - Genaues Ergebnis",
    "group": "all|score|ot"
  },
  "902": {
    "1640": "{$competitor1} mit Versuch",
    "1641": "{$competitor1} mit Strafstoß",
    "1642": "{$competitor1} mit Drop goal",
    "1643": "{$competitor2} mit Versuch",
    "1644": "{$competitor2} mit Strafstoß",
    "1645": "{$competitor2} mit Drop goal",
    "name": "Nächstes Scoring Play",
    "group": "all|score|regular_play"
  },
  "903": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Nächster Punkt (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "904": {
    "1945": "Touchdown",
    "1946": "Field Goal",
    "1947": "Safety",
    "1948": "Keiner",
    "name": "Nächster Scoring-Typ (inkl. OT)",
    "group": "all|score|incl_ot"
  },
  "905": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "1. HZ - nächster Treffer",
    "group": "all|score|1st_half"
  },
  "911": {
    "74": "ja",
    "76": "nein",
    "name": "Wird der Kampf über die volle Distanz gehen",
    "group": "all"
  },
  "914": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Passing Yards Gesamt (inkl. OT)",
    "group": "all"
  },
  "915": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Pass Completions Gesamt (inkl. OT)",
    "group": "all"
  },
  "916": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Passing Touchdowns Gesamt (inkl. OT)",
    "group": "all"
  },
  "917": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Carries Gesamt (inkl. OT)",
    "group": "all"
  },
  "918": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Rushing Yards Gesamt (inkl. OT)",
    "group": "all"
  },
  "919": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Receiving Yards Gesamt (inkl. OT)",
    "group": "all"
  },
  "920": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Receptions Gesamt (inkl. OT)",
    "group": "all"
  },
  "921": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Punkte Gesamt (inkl. OT)",
    "group": "all|score|incl_ot|player_props"
  },
  "922": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Assists Gesamt (inkl. OT)",
    "group": "all|incl_ot|player_props|assist"
  },
  "923": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} rebounds Gesamt (inkl. OT)",
    "group": "all|incl_ot|player_props|rebound"
  },
  "924": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} 3-Punkte Field Goals Gesamt (inkl. OT)",
    "group": "all|score|incl_ot|player_props"
  },
  "925": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Pitcher Strikeouts (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "926": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Bases Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "927": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Batter Runs + Runs batted in Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "928": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Erzielte Runs Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "929": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Paraden Gesamt (inkl. OT)",
    "group": "all"
  },
  "931": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Touchdowns Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "932": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Field Goals Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "933": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Ballverluste Gesamt (inkl. OT)",
    "group": "all"
  },
  "934": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Sacks Gesamt (inkl. OT)",
    "group": "all"
  },
  "940": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!fieldgoalnr} Field Goal verwandelt (inkl. OT)",
    "group": "all"
  },
  "956": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!timeoutnr} Timeout",
    "group": "all"
  },
  "959": {
    "1961": "Field Goal Versuch",
    "1962": "Offensive Touchdown",
    "1963": "Punt",
    "1964": "Turnover",
    "1965": "Safety",
    "name": "{!drivenr} drive - Ergebnis",
    "group": "all"
  },
  "960": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} Viertel - Letzter Punkt",
    "group": "all"
  },
  "961": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!freethrownr} Freiwurf erzielt",
    "group": "all"
  },
  "962": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Maximal aufeinanderfolgende Punkte Gesamt",
    "group": "all"
  },
  "963": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Insgesamt maximal aufeinanderfolgende Punkte",
    "group": "all"
  },
  "964": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Gesamtpunktzahl jedes Teams in Folge",
    "group": "all"
  },
  "965": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} führt mit {points}",
    "group": "all"
  },
  "966": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} führt mit {points}",
    "group": "all"
  },
  "967": {
    "74": "ja",
    "76": "nein",
    "name": "Führt ein Team mit {points}",
    "group": "all"
  },
  "970": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Über/Unter sixes Spread",
    "group": "all"
  },
  "971": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Multi Sixes Spread",
    "group": "all"
  },
  "972": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor1} 10/3 Sixes Head2Head Spread",
    "group": "all"
  },
  "973": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor2} 10/3 Sixes Head2Head Spread",
    "group": "all"
  },
  "974": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter Sixes Spread",
    "group": "all"
  },
  "975": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Sixes Spread",
    "group": "all"
  },
  "976": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Über/Unter Fours Spread",
    "group": "all"
  },
  "977": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Multi Fours Spread",
    "group": "all"
  },
  "978": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter Fours Spread",
    "group": "all"
  },
  "979": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Fours Spread",
    "group": "all"
  },
  "980": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor1} Joy of Six Spread",
    "group": "all"
  },
  "981": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{$competitor2} Joy of Six Spread",
    "group": "all"
  },
  "982": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Über/Unter {upsnr} Ups Spread",
    "group": "all"
  },
  "984": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter {upsnr} ups Spread",
    "group": "all"
  },
  "985": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter {upsnr} Ups Spread",
    "group": "all"
  },
  "988": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs 0 bis {overnr} - {$competitor1} Supremacy Spread",
    "group": "all"
  },
  "989": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs 0 bis {overnr} - {$competitor2} Supremacy Spread",
    "group": "all"
  },
  "992": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Über/Unter Wides Spread",
    "group": "all"
  },
  "993": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Multi Wides Spread",
    "group": "all"
  },
  "994": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning {!overnr} Over - Über/Unter runs Spread",
    "group": "all"
  },
  "995": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Multi Flyer Spread",
    "group": "all"
  },
  "996": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Über/Unter Run outs Spread",
    "group": "all"
  },
  "997": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Launch Spread",
    "group": "all"
  },
  "998": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "Spieler des Spiels Spielerleistung Spread",
    "group": "all"
  },
  "999": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{%player} Über/Unter Spielerleistung Spread",
    "group": "all"
  },
  "1000": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs {overnrX} x {overnrY} - {$competitor1} Multi Run Spread",
    "group": "all"
  },
  "1001": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning Overs {overnrX} x {overnrY} - {$competitor2} Multi Run Spread",
    "group": "all"
  },
  "1002": {
    "1890": "Sell",
    "1891": "Buy",
    "1892": "Mid",
    "name": "{!inningnr} Inning - {%player} {upsnr} ups Spread",
    "group": "all"
  },
  "1006": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "2 ball (Tipp)",
    "group": "all"
  },
  "1007": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "2 ball (handicap)",
    "group": "all"
  },
  "1008": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Strokes Gesamt",
    "group": "all"
  },
  "1010": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Eagles Gesamt",
    "group": "all"
  },
  "1011": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Birdies Gesamt",
    "group": "all"
  },
  "1012": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Pars Gesamt",
    "group": "all"
  },
  "1013": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Bogeys Gesamt",
    "group": "all"
  },
  "1014": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Über/Unter 2+ über Par",
    "group": "all"
  },
  "1016": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Eagles Gesamt",
    "group": "all"
  },
  "1017": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Birdies Gesamt",
    "group": "all"
  },
  "1018": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Pars Gesamt",
    "group": "all"
  },
  "1019": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Bogeys Gesamt",
    "group": "all"
  },
  "1020": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter 2+ über Par",
    "group": "all"
  },
  "1021": {
    "70": "ungerade",
    "72": "gerade",
    "name": "{%competitor} ungerade/gerade Stokes",
    "group": "all"
  },
  "1023": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Loch {holenr} - 2 Ball (Tipp)",
    "group": "all"
  },
  "1024": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Loch {holenr} - 2 Ball (Handicap)",
    "group": "all"
  },
  "1025": {
    "74": "ja",
    "76": "nein",
    "name": "Loch {holenr} - Jeder player unter Par",
    "group": "all"
  },
  "1026": {
    "74": "ja",
    "76": "nein",
    "name": "Loch {holenr} - {%competitor} unter Par",
    "group": "all"
  },
  "1028": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Löcher {from} bis {to} - 2 Ball (Tipp)",
    "group": "all"
  },
  "1029": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Loch {from} bis {to} - 2 ball (Handicap)",
    "group": "all"
  },
  "1030": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Löcher {from} bis {to} - 2 Ball (Tipp) Meiste Birdies",
    "group": "all"
  },
  "1031": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Löcher {from} bis {to} - 2 Ball (Tipp) Meiste Pars",
    "group": "all"
  },
  "1032": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Loch {from} bis {to} - 2 ball (Tipp) Meiste Bogeys",
    "group": "all"
  },
  "1036": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "unentschieden ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!quarternr} Viertel - Handicap {hcp}",
    "group": "all"
  },
  "1037": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Zuerst {goals} Tore",
    "group": "all"
  },
  "1040": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Hits Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1041": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Hits Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1042": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Hits Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1043": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - Über/Unter Hits",
    "group": "all"
  },
  "1044": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter hits",
    "group": "all"
  },
  "1045": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Hits",
    "group": "all"
  },
  "1046": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Inning 1 bis 5 - Über/Unter Hits",
    "group": "all"
  },
  "1047": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Inning 1 bis 5 - {$competitor1} Über/Unter Hits",
    "group": "all"
  },
  "1048": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Inning 1 bis 5 - {$competitor2} Über/Unter Hits",
    "group": "all"
  },
  "1049": {
    "1978": "Strike",
    "1979": "Ball",
    "1980": "Hit",
    "1981": "Andere",
    "name": "Ergebnis des {!pitchnr} Pitch",
    "group": "all|rapid_market|pitch"
  },
  "1050": {
    "74": "ja",
    "76": "nein",
    "name": "Hit auf {!pitchnr} Pitch",
    "group": "all|rapid_market|pitch"
  },
  "1051": {
    "74": "ja",
    "76": "nein",
    "name": "Home Run auf {!pitchnr} Pitch",
    "group": "all|rapid_market|pitch"
  },
  "1052": {
    "1982": "Single",
    "1983": "Double",
    "1984": "Triple",
    "1985": "Home Run",
    "1986": "Keinen weiteren Hit",
    "name": "Ergebnis von {!hitnr} Hit",
    "group": "all|rapid_market|hit"
  },
  "1053": {
    "1987": "auf der Base",
    "1988": "Out",
    "1989": "Home Run",
    "name": "Ergebnis von {%player} {!appearancenr} Zeit am Bat",
    "group": "all|player|rapid_market"
  },
  "1054": {
    "74": "ja",
    "76": "nein",
    "name": "{%player} striked out {!appearancenr} Zeit am Bat",
    "group": "all|player|rapid_market"
  },
  "1055": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Sieger & Über/Unter",
    "group": "all|regular_play|combo"
  },
  "1056": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "{!setnr} Satz - Sieger & Über/Unter",
    "group": "all|combo|set"
  },
  "1057": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!quarternr} Viertel - Wer erreicht zuerst {pointnr} Punkte",
    "group": "all|score|quarter"
  },
  "1061": {
    "1990": "Rush",
    "1991": "Pass",
    "name": "{!drivenr} Drive play {playnr} - {%competitor} Play type",
    "group": "all|drive"
  },
  "1062": {
    "74": "ja",
    "76": "nein",
    "name": "{!drivenr} Drive play {playnr} - {%competitor} Erfolgreicher Pass",
    "group": "all|drive"
  },
  "1063": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!drivenr} Drive play {playnr} - {%competitor} Über/Unter Yards gewonnen",
    "group": "all|drive"
  },
  "1064": {
    "74": "ja",
    "76": "nein",
    "name": "{!drivenr} Drive play {playnr} - {%competitor} neues First down",
    "group": "all|drive"
  },
  "1065": {
    "74": "ja",
    "76": "nein",
    "name": "{!drivenr} Drive play {playnr} - {%competitor} Sack",
    "group": "all|drive"
  },
  "1066": {
    "1992": "Punt",
    "1993": "Touchdown",
    "1994": "Field Goal Versuch",
    "1995": "Andere",
    "name": "{!drivenr} drive - {%competitor} Ergebnis",
    "group": "all|drive"
  },
  "1067": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Sieger & Über/Unter (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1068": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es einen Grand Slam geben (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1069": {
    "74": "ja",
    "76": "nein",
    "name": "Gewinnt ein Team zu Null (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1070": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning - Meiste Strikes",
    "group": "all"
  },
  "1071": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning - Meiste Bälle",
    "group": "all"
  },
  "1072": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} Inning - Meiste Hits",
    "group": "all"
  },
  "1073": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} Inning - Genaue Home Runs",
    "group": "all"
  },
  "1074": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} Inning - {$competitor1} Genaue Home Runs",
    "group": "all"
  },
  "1075": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} Inning - {$competitor2} Genaue Homeruns",
    "group": "all"
  },
  "1076": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - Über/Unter pitches",
    "group": "all"
  },
  "1077": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor1} Über/Unter Pitches",
    "group": "all"
  },
  "1078": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {$competitor2} Über/Unter Pitches",
    "group": "all"
  },
  "1079": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} Inning - {$competitor1} Genaue Strikeouts",
    "group": "all"
  },
  "1080": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} Inning - {$competitor2} Genaue Strikeouts",
    "group": "all"
  },
  "1081": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor1} verzeichnet ein Double or Triple play",
    "group": "all"
  },
  "1082": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {$competitor2} verzeichnet ein Double oder Triple",
    "group": "all"
  },
  "1083": {
    "2005": "1-3",
    "2006": "4-5",
    "2007": "6+",
    "name": "Pitch Range von {%player} {!appearancenr} Zeit am Bat",
    "group": "all"
  },
  "1084": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "Genaue Strikes von {%player} {!appearancenr} Zeit am Bat",
    "group": "all"
  },
  "1085": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "Genaue Bälle von {%player} {!appearancenr} Zeit am Bat",
    "group": "all"
  },
  "1086": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Gesamtgeschwindigkeit von {!pitchnr} Pitch",
    "group": "all"
  },
  "1087": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Genaue Anzahl Home Runs (inkl. Extra Innings)",
    "group": "all|incl_ei"
  },
  "1088": {
    "2008": "{$competitor1} 1 Punkt",
    "2009": "{$competitor1} 2 Punkte",
    "2010": "{$competitor1} 3 Punkte",
    "2011": "{$competitor2} 1 Punkt",
    "2012": "{$competitor2} 2 Punkte",
    "2013": "{$competitor2} 3 Punkte",
    "name": "Scoring-Typ {!pointnr} Punkt (inkl. OT)",
    "group": "all"
  },
  "1089": {
    "2014": "1 Punkt",
    "2015": "2 Punkte",
    "2016": "3 Punkte",
    "name": "Jeder Team Scoring-Typ {!pointnr} Punkt (inkl. OT)",
    "group": "all"
  },
  "1090": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} Viertel - {!pointnr} Punkt",
    "group": "all"
  },
  "1096": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Runden Gesamt bei {!stopnr} Boxenstopp",
    "group": "all"
  },
  "1097": {
    "2017": "1-2",
    "2018": "3-4",
    "2019": "5-6",
    "2020": "7-8",
    "2021": "9-10",
    "2022": "11+",
    "name": "Grid-Positionsbereich des Siegers",
    "group": "all"
  },
  "1098": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Führungswechsel Gesamt",
    "group": "all"
  },
  "1099": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter Finishers",
    "group": "all"
  },
  "1100": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Führungswechsel Gesamt",
    "group": "all"
  },
  "1106": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%team} Führungswechsel Gesamt",
    "group": "all"
  },
  "1108": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!lapnr} Runde - Aufgaben Gesamt",
    "group": "all"
  },
  "1119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Zuerst {pointnr} Punkte",
    "group": "all"
  },
  "1120": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Home Runs Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei|home_run"
  },
  "1121": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Home Runs Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei|home_run"
  },
  "1122": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Home Runs Gesamt (inkl. Extra Innings)",
    "group": "all|incl_ei|home_run"
  },
  "1123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!inningnr} Inning - Sieger",
    "group": "all|inning"
  },
  "1124": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Inning 1 bis 5 - Sieger",
    "group": "all|5_innings"
  },
  "1125": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {%player1} erzielt {milestone} & {%player2} {total} + Dismissals",
    "group": "all"
  },
  "1127": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {%player1} erzielt {milestone1} & {%player2} erzielt {milestone2}",
    "group": "all"
  },
  "1128": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {%player1} & {%player2} erzielen {milestone} & {%player3} {total} + Dismissals",
    "group": "all"
  },
  "1129": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player1} + {%player2} Über/Unter",
    "group": "all"
  },
  "1130": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player1} + {%player2} + {%player3} Über/Unter",
    "group": "all"
  },
  "1131": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Teams erzielen {milestone}",
    "group": "all"
  },
  "1132": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningsnr} Inning Over {overnr} - Deliveries {deliverynr1} & {deliverynr2} {$competitor1} {total} +",
    "group": "all"
  },
  "1133": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningsnr} Inning Over {overnr} - Deliveries {deliverynr1} & {deliverynr2} {$competitor2} {total} +",
    "group": "all"
  },
  "1134": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Inning - {%player1} & {%player2} Dismissal method",
    "group": "all"
  },
  "1135": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Welches Team hat die höchste 1. Partnerschaft & 1. Over & Overs 0 bis {overnr}",
    "group": "all"
  },
  "1136": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "Andere",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor1} Genaue Runs",
    "group": "all"
  },
  "1137": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "Andere",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor2} Genaue Runs",
    "group": "all"
  },
  "1138": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor1} ist ein Wicket",
    "group": "all"
  },
  "1139": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {!deliverynr} Delivery {$competitor2} wird ein Wicket",
    "group": "all"
  },
  "1140": {
    "1806": "Fielder Catch",
    "1807": "Bowled",
    "1808": "Keeper Catch",
    "1809": "lbw",
    "1810": "Run out",
    "1811": "Stumped",
    "1812": "andere",
    "name": "{!inningnr} Inning - {%player1} oder {%player2} Dismissal Method",
    "group": "all"
  },
  "1141": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Innings Over {overnr} - {%player1} & {%player2} treffen die Begrenzung",
    "group": "all"
  },
  "1142": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Innings Over {overnr} - {%player1} & {%player2} {total} +",
    "group": "all"
  },
  "1143": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor1} erzielt ein Boundary-Four & einen Six",
    "group": "all"
  },
  "1144": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning Over {overnr} - {$competitor2} erzielt ein Boundary-Four & einen Six",
    "group": "all"
  },
  "1145": {
    "74": "ja",
    "76": "nein",
    "name": "{!inningnr} Inning - {%player1} oder {%player2} überstehen einen Review",
    "group": "all"
  },
  "1146": {
    "2023": "{%player1}",
    "2024": "Keine",
    "2025": "{%player2}",
    "name": "{!inningnr} Inning - Bis zu {runs} Runs",
    "group": "all"
  },
  "1147": {
    "74": "ja",
    "76": "nein",
    "name": "{%player} erzielt {milestone} & nimmt einen Wicket & einen Catch",
    "group": "all"
  },
  "1148": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!overnr} Over - {$competitor1} Über/Unter ({ballcount}-Ball Overs)",
    "group": "all"
  },
  "1149": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!overnr} Over - {$competitor2} Über/Unter ({ballcount}-Ball Overs)",
    "group": "all"
  },
  "1150": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Overs 0 bis {overnr} - {$competitor1} Über/Unter ({ballcount}-Ball overs)",
    "group": "all"
  },
  "1151": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Overs 0 bis {overnr} - {$competitor2} Über/Unter ({ballcount}-Ball overs)",
    "group": "all"
  },
  "1152": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter Rushing Touchdowns (inkl. OT)",
    "group": "all"
  },
  "1158": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "2 Ball",
    "group": "all"
  },
  "1160": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Keine Wette",
    "group": "all"
  },
  "1161": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Head2Head (Tipp)",
    "group": "all"
  },
  "1162": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Loch Handicap",
    "group": "all"
  },
  "1163": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} Gewonnene Löcher Gesamt",
    "group": "all"
  },
  "1165": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Gespielte Löcher Gesamt",
    "group": "all"
  },
  "1166": {
    "74": "ja",
    "76": "nein",
    "name": "Wird es ein Unentschieden geben",
    "group": "all"
  },
  "1168": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Loch {holenr} - Head2Head (Tipp)",
    "group": "all"
  },
  "1169": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Loch {holenr} - keine Wette",
    "group": "all"
  },
  "1170": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Löcher {from} bis {to} - Head2Head (Tipp)",
    "group": "all"
  },
  "1171": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Löcher {from} bis {to} - Keine Wette",
    "group": "all"
  },
  "1173": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Sieger (inklusive OT) & Über/Unter (inklusive OT)",
    "group": "all"
  },
  "1174": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "Handicap (inklusive OT) & Über/Unter (inklusive OT)",
    "group": "all|combo|incl_ot"
  },
  "1175": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1. Viertel Tipp & 1. Viertel Über/Unter",
    "group": "all|combo|incl_ot"
  },
  "1176": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1. Viertel Handicap & 1. Viertel Über/Unter",
    "group": "all|combo|incl_ot"
  },
  "1177": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1. Hälfte Tipp & 1. Hälfte Über/Unter",
    "group": "all|combo|incl_ot"
  },
  "1178": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1. Hälfte Handicap & 1. Hälfte Über/Unter",
    "group": "all|combo|incl_ot"
  },
  "1179": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Ergebnis 1. HZ oder Spielergebnis",
    "group": "all|regular_play"
  },
  "1183": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Schüsse Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "1185": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Schüsse aufs Tor Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "1187": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Pässe Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "1189": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Tackles Gesamt (inkl. OT)",
    "group": "all|incl_ot"
  },
  "1193": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Highest scoring quarter - Über/Unter",
    "group": "all|score|regular_play"
  },
  "1195": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Lowest scoring quarter - Über/Unter",
    "group": "all|score|regular_play"
  },
  "1197": {
    "74": "ja",
    "76": "nein",
    "name": "Any team to win both halves",
    "group": "all|score|regular_play"
  },
  "1199": {
    "74": "ja",
    "76": "nein",
    "name": "Any team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1201": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Team to win both halves",
    "group": "all|score|regular_play"
  },
  "1203": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1207": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Nächstes {!breaknr} Break",
    "group": "all"
  },
  "1209": {
    "2039": "{$competitor1} 6-0, 6-1, 6-2",
    "2040": "{$competitor1} 6-3, 6-4",
    "2041": "{$competitor1} 7-5, 7-6",
    "2042": "{$competitor2} 6-0, 6-1, 6-2",
    "2043": "{$competitor2} 6-3, 6-4",
    "2044": "{$competitor2} 7-5, 7-6",
    "name": "{!setnr} Satz - exakte Punktegruppe",
    "group": "all"
  },
  "1211": {
    "74": "ja",
    "76": "nein",
    "name": "Spiel endet {score}",
    "group": "all"
  },
  "1214": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Deliveries faced Gesamt",
    "group": "all"
  },
  "1215": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning - {%player} Runs kassiert",
    "group": "all"
  },
  "1218": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} Inning - {$competitor1} nächster boundary {boundary number} off Bat, Four oder Six",
    "group": "all"
  },
  "1219": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} Inning - {$competitor2} nächster boundary {boundary number} off Bat, Four oder Six",
    "group": "all"
  },
  "1220": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Batsman milestones Gesamt (50s/100s)",
    "group": "all"
  },
  "1221": {
    "1037": "gefangen",
    "1038": "nicht gefangen",
    "name": "{!inningnr} Inning - {$competitor1} {!dismissalnr} Dismissal Methode (limited)",
    "group": "all"
  },
  "1222": {
    "1037": "gefangen",
    "1038": "nicht gefangen",
    "name": "{!inningnr} Inning - {$competitor2} {!dismissalnr} Dismissal Methode (limited)",
    "group": "all"
  },
  "1229": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning overs 0 zu {overnr} - {$competitor1} Gesamt",
    "group": "all"
  },
  "1230": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} Inning overs 0 zu {overnr} - {$competitor2} Gesamt",
    "group": "all"
  },
  "1231": {
    "74": "ja",
    "76": "nein",
    "name": "Genaue Summe der Bonusbälle",
    "group": "all"
  },
  "1242": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Wer erreicht zuerst Heim {homepoints} und Auswärts {awaypoints} Punkte",
    "group": "all"
  },
  "1243": {
    "74": "ja",
    "76": "nein",
    "name": "Jederzeit Genaues Ergebnis {homepoints}:{awaypoints}",
    "group": "all"
  },
  "1244": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "King of the Oche (Match-Dreier)",
    "group": "all"
  },
  "1246": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Spieler mit dem höchsten Checkout",
    "group": "all"
  },
  "1248": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Höchster Checkout im Spiel",
    "group": "all"
  },
  "1250": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Gesamt {points} + Checkouts",
    "group": "all"
  },
  "1252": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Sieger & höchster Checkout",
    "group": "all"
  },
  "1254": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Sieger & meiste 180er",
    "group": "all"
  },
  "1256": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "Höchster Checkout & meiste 180er",
    "group": "all"
  },
  "1258": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Führend nach dem {!legnr} Leg",
    "group": "all"
  },
  "1260": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!legnr} Leg Checkout Gesamt",
    "group": "all"
  },
  "1264": {
    "74": "ja",
    "76": "nein",
    "name": "170 Checkout im Spiel",
    "group": "all"
  },
  "1269": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Spiel {gamenr} - Ass",
    "group": "all|micro_market"
  },
  "1270": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!setnr} Satz - {!acenr} Ass",
    "group": "all|micro_market"
  },
  "1271": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor1} Punkte Gesamt",
    "group": "all|player_props"
  },
  "1272": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor2} Punkte Gesamt",
    "group": "all|player_props"
  },
  "1273": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor2} Breaks Gesamt",
    "group": "all|player_props"
  },
  "1274": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor1} Asse Gesamt",
    "group": "all|player_props"
  },
  "1275": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor2} Asse Gesamt",
    "group": "all|player_props"
  },
  "1276": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} Satz - Meiste Asse",
    "group": "all|player_props"
  },
  "1277": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} Satz - {$competitor1} Breaks Gesamt",
    "group": "all|player_props"
  },
  "1278": {
    "74": "ja",
    "76": "nein",
    "name": "Beide Spieler gewinnen einen Satz",
    "group": "all|score|regular_play"
  },
  "1279": {
    "2047": "4:0",
    "2048": "3:1",
    "2049": "2:2",
    "2050": "1:3",
    "2051": "0:4",
    "name": "{!setnr} Satz - Korrektes Ergebnis nach 4 Spielen",
    "group": "all|score|set"
  },
  "1280": {
    "2052": "6:0",
    "2053": "5:1",
    "2054": "4:2",
    "2055": "3:3",
    "2056": "2:4",
    "2057": "1:5",
    "2058": "0:6",
    "name": "{!setnr} Satz - Korrektes Ergebnis nach 6 Spielen",
    "group": "all|score|set"
  },
  "1281": {
    "6": "{$competitor1}",
    "7": "X",
    "8": "{$competitor2}",
    "name": "{!setnr} Satz - {!breaknr} Break",
    "group": "all|score|set|micro_market"
  },
  "1282": {
    "74": "ja",
    "76": "nein",
    "name": "{!setnr} Satz Spiel {gamenr} - Breakpoint",
    "group": "all|score|game|micro_market"
  },
  "1283": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Booking Handicap",
    "group": "all|regular_play|bookings"
  },
  "1284": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Verlängerung 1. HZ - Über/Unter",
    "group": "all|score|ot_1st_half"
  },
  "1285": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter points",
    "group": "all|score|regular_play|player_props"
  },
  "1286": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter points",
    "group": "all|score|regular_play|player_props"
  },
  "1287": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1288": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1289": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1290": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1291": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1292": {
    "2059": "point after rally",
    "2060": "ace",
    "2061": "double fault",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point serve outcome",
    "group": "all|score|points|micro_market"
  },
  "1293": {
    "2064": "{$competitor1} winner",
    "2065": "{$competitor2} winner",
    "2066": "{$competitor1} error",
    "2067": "{$competitor2} error",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point outcome",
    "group": "all|score|points|micro_market"
  },
  "1294": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point Über/Unter shots",
    "group": "all|score|points|micro_market"
  },
  "1295": {
    "2068": "serve",
    "2069": "return",
    "2070": "forehand",
    "2071": "backhand",
    "2072": "volley",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point last stroke",
    "group": "all|score|points|micro_market"
  },
  "1296": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter yellow cards",
    "group": "all|regular_play|bookings"
  },
  "1297": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Über/Unter red cards",
    "group": "all|regular_play|bookings"
  },
  "1298": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Yellow card Tipp",
    "group": "all|regular_play|bookings"
  },
  "1299": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Yellow card handicap",
    "group": "all|regular_play|bookings"
  },
  "1300": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter points (incl. overtime)",
    "group": "all"
  },
  "1301": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter assists (incl. overtime)",
    "group": "all"
  },
  "1302": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter rebounds (incl. overtime)",
    "group": "all"
  },
  "1303": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter 3-point field goals (incl. overtime)",
    "group": "all"
  },
  "1304": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} Über/Unter points + rebounds + assists (incl. overtime)",
    "group": "all|combo|incl_ot|player_props"
  },
  "1305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st half - {points} point score draw no bet",
    "group": "all|score|1st_half|micro_market"
  },
  "1306": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd half - {points} point score draw no bet",
    "group": "all|score|2nd_half|micro_market"
  },
  "1307": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {points} point score draw no bet",
    "group": "all|score|quarter|micro_market"
  },
  "1308": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1309": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1310": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1311": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1312": {
    "2073": "score",
    "2074": "no score",
    "name": "{!possessionnr} possession outcome",
    "group": "all|score|regular_play|micro_market"
  },
  "1313": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor1} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1314": {
    "74": "ja",
    "76": "nein",
    "name": "{$competitor2} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1315": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} Über/Unter double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1316": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} Über/Unter double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1500": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rest of Über/Unter match",
    "group": "all"
  },
  "1601": {
    "16001": "{$competitor1} & 2-3 goals",
    "16002": "{$competitor1} & 2-4 goals",
    "16003": "{$competitor1} & 2-5 goals",
    "16004": "{$competitor1} & 3-4 goals",
    "16005": "{$competitor1} & 3-5 goals",
    "16006": "{$competitor1} & 3-6 goals",
    "16007": "draw & 2-3 goals",
    "16008": "draw & 2-4 goals",
    "16009": "draw & 2-5 goals",
    "16010": "draw & 3-4 goals",
    "16011": "draw & 3-5 goals",
    "16012": "draw & 3-6 goals",
    "16013": "{$competitor2} & 2-3 goals",
    "16014": "{$competitor2} & 2-4 goals",
    "16015": "{$competitor2} & 2-5 goals",
    "16016": "{$competitor2} & 3-4 goals",
    "16017": "{$competitor2} & 3-5 goals",
    "16018": "{$competitor2} & 3-6 goals",
    "name": "Tipp & Multigoals",
    "group": "all"
  },
  "1602": {
    "16021": "{$competitor1} or draw & 2-3 goals",
    "16022": "{$competitor1} or draw & 2-4 goals",
    "16023": "{$competitor1} or draw & 2-5 goals",
    "16024": "{$competitor1} or draw & 3-4 goals",
    "16025": "{$competitor1} or draw & 3-5 goals",
    "16026": "{$competitor1} or draw & 3-6 goals",
    "16027": "{$competitor1} or {$competitor2} & 2-3 goals",
    "16028": "{$competitor1} or {$competitor2} & 2-4 goals",
    "16029": "{$competitor1} or {$competitor2} & 2-5 goals",
    "16030": "{$competitor1} or {$competitor2} & 3-4 goals",
    "16031": "{$competitor1} or {$competitor2} & 3-5 goals",
    "16032": "{$competitor1} or {$competitor2} & 3-6 goals",
    "16033": "draw or {$competitor2} & 2-3 goals",
    "16034": "draw or {$competitor2} & 2-4 goals",
    "16035": "draw or {$competitor2} & 2-5 goals",
    "16036": "draw or {$competitor2} & 3-4 goals",
    "16037": "draw or {$competitor2} & 3-5 goals",
    "16038": "draw or {$competitor2} & 3-6 goals",
    "name": "Double chance & Multigoals",
    "group": "all"
  },
  "1603": {
    "16040": "0:0/1:1",
    "16041": "0:1/0:2/1:2",
    "16042": "0:3/1:3/2:3",
    "16043": "1:0/2:0/2:1",
    "16044": "1:4/2:4/3:4",
    "16045": "2:2/3:3/4:4",
    "16046": "3:0/3:1/3:2",
    "16047": "4:1/4:2/4:3",
    "16048": "4:0/0:4/Other",
    "name": "Multiscore-3",
    "group": "all"
  },
  "1604": {
    "16050": "0:0/1:1/0:1/1:0",
    "16051": "0:2/1:2/0:3/1:3",
    "16052": "0:4/1:4/2:4/3:4",
    "16053": "2:0/2:1/3:0/3:1",
    "16054": "2:2/2:3/3:2/3:3",
    "16055": "4:0/4:1/4:2/4:3",
    "16056": "4:4/Other",
    "name": "Multiscore-4",
    "group": "all"
  },
  "1605": {
    "16057": "{$competitor1} or no",
    "16058": "{$competitor1} or yes",
    "16059": "{$competitor2} or no",
    "16060": "{$competitor2} or yes",
    "16061": "draw or no",
    "16062": "draw or yes",
    "name": "Tipp or both teams to score",
    "group": "all"
  },
  "1606": {
    "16063": "{$competitor1}/draw / {$competitor1}/draw",
    "16064": "{$competitor1}/draw / {$competitor1}/{$competitor2}",
    "16065": "{$competitor1}/draw / draw/{$competitor2}",
    "16066": "{$competitor1}/{$competitor2} / {$competitor1}/draw",
    "16067": "{$competitor1}/{$competitor2} / draw/{$competitor2}",
    "16068": "draw/{$competitor2} / {$competitor1}/draw",
    "16069": "{$competitor1}/{$competitor2} / {$competitor1}/{$competitor2}",
    "16070": "draw/{$competitor2} / {$competitor1}/{$competitor2}",
    "16071": "draw/{$competitor2} / draw/{$competitor2}",
    "name": "Double chance Halftime/Fulltime",
    "group": "all"
  },
  "1607": {
    "16072": "{$competitor1} or {total} over",
    "16073": "draw or {total} over",
    "16074": "{$competitor2} or {total} over",
    "16075": "{$competitor1} or {total} under",
    "16076": "draw or {total} under",
    "16077": "{$competitor2} or {total} under",
    "name": "Tipp or {total} Über/Unter",
    "group": "all"
  },
  "1608": {
    "16078": "yes or {total} over",
    "16079": "yes or {total} under",
    "16080": "no or {total} over",
    "16081": "no or {total} under",
    "name": "Both team to score or {total} Über/Unter",
    "group": "all"
  },
  "1609": {
    "16082": "{$competitor1} and yes and {total} over",
    "16083": "{$competitor1} and no and {total} over",
    "16084": "{$competitor1} and no and {total} under",
    "16085": "draw and yes and {total} over",
    "16086": "draw and yes and {total} under",
    "16087": "draw and no and {total} under",
    "16088": "{$competitor2} and yes and {total} over",
    "16089": "{$competitor2} and no and {total} over",
    "16090": "{$competitor2} and no and {total} under",
    "name": "Tipp and Both team to score and {total} Über/Unter",
    "group": "all"
  },
  "1610": {
    "16091": "<1 and <1",
    "16092": ">=1 and >=1",
    "16093": "<1 and <2",
    "16094": ">=1 and >=2",
    "16095": "<1 and <3",
    "16096": ">=1 and >=3",
    "16097": "<2 and <1",
    "16098": ">=2 and >=1",
    "16099": "<2 and <2",
    "16100": ">=2 and >=2",
    "16101": "<2 and <3",
    "16102": ">=2 and >=3",
    "16103": "<3 and <1",
    "16104": ">=3 and >=1",
    "16105": ">=3 and >=2",
    "16106": ">=3 and >=3",
    "name": "Exact goals in HT/2HT",
    "group": "all"
  },
  "1612": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 5 minutes",
    "group": "all"
  },
  "1613": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 10 minutes",
    "group": "all"
  },
  "1614": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 15 minutes",
    "group": "all"
  },
  "1615": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 20 minutes",
    "group": "all"
  },
  "1616": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 30 minutes",
    "group": "all"
  },
  "1617": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Tipp in 60 minutes",
    "group": "all"
  },
  "1618": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 5 min",
    "group": "all"
  },
  "1619": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 10 min",
    "group": "all"
  },
  "1620": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 15 min",
    "group": "all"
  },
  "1621": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 20 min",
    "group": "all"
  },
  "1622": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 30 min",
    "group": "all"
  },
  "1623": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 60 min",
    "group": "all"
  },
  "1624": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 2 goals in a row",
    "group": "all"
  },
  "1625": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1626": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 2 goals in a row",
    "group": "all"
  },
  "1627": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 3 goals in a row",
    "group": "all"
  },
  "1628": {
    "74": "yes",
    "76": "no",
    "name": "Any 2 goals in a row",
    "group": "all"
  },
  "1629": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1630": {
    "74": "yes",
    "76": "no",
    "name": "Both team to score 2+",
    "group": "all"
  },
  "1631": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Halftime or fulltime",
    "group": "all"
  },
  "1632": {
    "1724": "{$competitor1}/draw & {total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "draw/{$competitor2} & {total} -",
    "1727": "{$competitor1}/draw & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "draw/{$competitor2} & {total} +",
    "name": "1st half - Double chance and Über/Unter Halftime or Fulltime",
    "group": "all"
  },
  "1633": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "Double chance (1st half) & Tipp",
    "group": "all"
  },
  "1634": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "Tipp (1st half) & Double chance",
    "group": "all"
  }
};

export const global_marketname = {
  7: "Restzeit",
  8: "N\xe4chstes Tor",
  18: "\xdcber/Unter",
  19: "Heim Total",
  20: "G\xe4st Total",
  1: "Tipp",
  10: "Doppelchance",
  219: "12 Einschlie\xdflich \xdcberstunden",
  225: "Unter/\xdcber, einschlie\xdflich \xdcberstunden",
  251: "Gewinner",
  258: "Unter/\xdcber, einschlie\xdflich \xdcberstunden",
  340: "Gewinner",
  186: "Gewinner"
};
